import React, { useState ,useEffect,useRef} from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import '../Customize_Css/ViewVendor.css';
import { Button} from '@mui/material';
import { styled } from '@mui/material/styles';
import '../Customize_Css/AddDeliveryVendor.css';
import { Dropdown, Modal, Form } from 'react-bootstrap';
import { FaTrashAlt, FaEdit, FaFileExport, FaEye, FaFileAlt } from 'react-icons/fa';
import * as XLSX from 'xlsx';
import location from '../Icons/location.svg';
import uploadicon from '../Icons/upload white.svg';
// import add from '../Icons/Add.svg';
import deleteicon from '../Icons/delete.svg';
import cancelicon from '../Icons/Add.svg';
import editIcon from '../Images/EditIcon.svg';
import viewIcon from '../Images/view.png';
import agent from '../Icons/agent.svg';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { prepareUploadFile, getUploadErrorMessage } from '../utils/prepareUploadFile';
import 'react-toastify/dist/ReactToastify.css';
import removeIcon from '../Icons/Close-white.svg';
import Select from 'react-select';
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import iconRetinaUrl from "leaflet/dist/images/marker-icon-2x.png";
import iconUrl from "leaflet/dist/images/marker-icon.png";
import shadowUrl from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
});

const AddDeliveryVendor = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id: agentRouteId } = useParams();
  const isAgentsPage = location.pathname.includes('view-delivery-vendor-agents');
  const isAddAgentPage = location.pathname.includes('/add-delivery-agent');
  const isEditAgentPage = location.pathname.includes('/update-delivery-agent');
  const isAgentFormPage = isAddAgentPage || isEditAgentPage;
  const [errors, setErrors] = useState({});
  const [validFields, setValidFields] = useState({});
  const [isCollapsed, setIsCollapsed] = useState(false);
  const epicxTenantId = localStorage.getItem('epicxTenantId');
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const AuthorizationToken = localStorage.getItem('token');
  console.log("epicxTenantId", epicxTenantId);
  const [timeAvailabilitySlot, setTimeAvailabilitySlot] = useState([]);
  const [daySlot, setDaySlot] = useState([]);
  const [show, setShow] = useState(false);
  const [showAgentEdit, setShowAgentEdit] = useState(false);
  const [agents, setAgents] = useState([]);
  const [selectedAgentIds, setSelectedAgentIds] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [deliveryVendors, setDeliveryVendors] = useState([]);
  const [loading, setLoading] = useState(true)
  const [isLocationPicked, setIsLocationPicked] = useState({ latitude: '', longitude: '' });
  const [isMapOpen, setIsMapOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [manualLat, setManualLat] = useState("");
  const [manualLng, setManualLng] = useState("");
  const [mapMarker, setMapMarker] = useState(null);
  const mapRef = useRef(null);
  // Add these states (for Agent only)
  const [agentLocation, setAgentLocation] = useState(null); 
  const [agentMapMarker, setAgentMapMarker] = useState(null);
  const [agentManualLat, setAgentManualLat] = useState("");
  const [agentManualLng, setAgentManualLng] = useState("");
  const [agentSearchQuery, setAgentSearchQuery] = useState("");
  const [isAgentMapOpen, setIsAgentMapOpen] = useState(false); 
  function MapClickHandler({ onSelect }) {
  useMapEvents({
    click(e) {
      const { lat, lng } = e.latlng;
      onSelect({ lat, lng });
    },
  });
  return null;
}
const updateLocation = (loc) => {
  setSelectedLocation(loc);
  setMapMarker(loc);
  setManualLat(loc.lat.toFixed(6));
  setManualLng(loc.lng.toFixed(6));
};
const handleGeocode = async () => {
  if (!searchQuery.trim()) return;

  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchQuery)}`
    );
    const data = await res.json();
    if (data.length === 0) {
      toast.error("Location not found");
      return;
    }
    const { lat, lon } = data[0];
    const newLoc = { lat: parseFloat(lat), lng: parseFloat(lon) };
    updateLocation(newLoc);

    if (mapRef.current) {
      mapRef.current.setView(newLoc, 16);
    }
  } catch (err) {
    toast.error("Search failed");
  }
};
useEffect(() => {
  if (isEditAgentPage && agentRouteId) {
    handleAgentEditShow(agentRouteId);
  } else if (isAddAgentPage) {
    setDeliveryVendorAgentsData({
      fullName: '', bloodGroup: '', address: '', whatsAppNumber: '',
      emergencyContactNumber: '', languagesKnown: [], aadharNumber: '',
      rcBookNumber: '', vehicleNumber: '', accountNumber: '', ifscCode: '',
      branchAddress: '', panNumber: '', drivingLicenseNumber: '',
      deliveryVendorName: '', deliveryVendorEmail: '', deliveryVendorId: '',
      useMyLocation: { latitude: '', longitude: '' }, currentLocation: '',
    });
    setUploadedFiles({});
    setAgentLocation(null);
    setAgentMapMarker(null);
    setAgentManualLat('');
    setAgentManualLng('');
    setErrors({});
    setValidFields({});
  }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [isEditAgentPage, isAddAgentPage, agentRouteId]);
useEffect(() => {
  if (isMapOpen && mapRef.current) {
    setTimeout(() => {
      mapRef.current.invalidateSize();
    }, 300);
  }
}, [isMapOpen]);

  const handleClose = () => navigate('/view-delivery-vendor-agents');
  const handleShow = () => navigate('/add-delivery-agent');
  const handleAgentEditClose = () => {
    setShowAgentEdit(false);
    setSelectedAgent(null);
    navigate('/view-delivery-vendor-agents');
  };

  const Input = styled('input')({
    display: 'none',
  });
  
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const fieldName = event.target.name; 
    if (file) {
      console.log(`Field: ${fieldName}, File: ${file.name}`); 
      setFiles((prevFiles) => ({
        ...prevFiles,
        [fieldName]: file, 
      }));
    }
  };
  const handleButtonClick = (time) => {
    setTimeAvailabilitySlot([time]); 
  };
  const handleDaysButtonClick = (day) => {
    setDaySlot(prevDays =>
      prevDays.includes(day)
        ? prevDays.filter(d => d !== day)
        : [...prevDays, day]
    );
  };
  
const handleAccountTypeChange = (accountType) => {
  setFormData((prevFormData) => ({
    ...prevFormData,
    typeOfAccount: accountType, 
  }));
};
const [formData, setFormData] = useState({
  deliveryVendorShopName: '',
  fullName: '',
  emailAddress: '',
  degree: '',
  primaryMobileNumber: '',
  whatsappNumber: '',
  country: '',
  state: '',
  city: '',
  dateOfBirth: '',
  gstNumber: '',
  panNumber: '',
  address: '',
  useMyLocation: { latitude: '', longitude: '' },
  currentLocation: '',
  timeAvailabilitySlot: JSON.stringify([]),
  daySlot: JSON.stringify([]),
  nameOfEmergency: '',
  relationshipToAccountHolder: '',
  emergencyPhoneNumber: '',
  emergencyEmailAddress: '',
  emergencyAddress: '',
  alternateContactPersonName: '',
  relationshipToAlternateContactPerson: '',
  alternateContactPersonNumber: '',
  alternateContactPersonAddress: '',
  toPickupLocationTime: '',
  toDeliveryLocationTime: '',
  maximumDeliveryCapacity: '',
  accountHoldersName: '',
  typeOfAccount: '',
  accountNumber: '',
  ifscCode: '',
  branchName: '',
  gpayNumber: '',
  bankAddress: ''
});
const [files, setFiles] = useState({
  gstFile: null,
  panFile: null,
  profilePictureFile: null
});
const handleFileRemove = (fileType) => {
  setFiles((prevFiles) => ({
    ...prevFiles,
    [fileType]: null 
  }));
};
const handleInputChange = (e) => {
  const { name, value } = e.target;
  setFormData(prevData => ({ ...prevData, [name]: value }));
   if (value.trim()) {
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); 
    setValidFields((prevValid) => ({ ...prevValid, [name]: true }));
  } else {
    setValidFields((prevValid) => ({ ...prevValid, [name]: false })); 
  }
};

const validateFormDeliveryVendor = () => {
  let errors = {};
  let isValid = true;
  const isValidIFSC = (ifsc) => /^[A-Za-z]{4}\d{7}$/.test(ifsc);
  const isEmpty = (value) => !value || value.trim() === "";
  const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const isValidMobileNumber = (number) =>
    /^[0-9]{10}$/.test(number);

  //check GST format (15 characters alphanumeric)
  const isValidGST = (gst) =>
    /^[0-9A-Z]{15}$/.test(gst);

  //check PAN format (5 letters, 4 digits, 1 letter)
  const isValidPAN = (pan) =>
    /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan);

  //Checking required fields
  if (isEmpty(formData.deliveryVendorShopName)) {
    errors.deliveryVendorShopName = "Delivery Vendor Shop Name is required";
    isValid = false;
  }
  if (isEmpty(formData.fullName)) {
    errors.fullName = "Full Name is required";
    isValid = false;
  }
  if (isEmpty(formData.emailAddress) || !isValidEmail(formData.emailAddress)) {
    errors.emailAddress = "Valid Email Address is required";
    isValid = false;
  }
  if (isEmpty(formData.degree)) {
    errors.degree = "Degree is required";
    isValid = false;
  }
  if (isEmpty(formData.primaryMobileNumber) || !isValidMobileNumber(formData.primaryMobileNumber)) {
    errors.primaryMobileNumber = "Valid 10-digit Primary Mobile Number is required";
    isValid = false;
  }
  if (isEmpty(formData.whatsappNumber) || !isValidMobileNumber(formData.whatsappNumber)) {
    errors.whatsappNumber = "Valid 10-digit Primary Mobile Number is required";
    isValid = false;
  }
  if (isEmpty(formData.country)) {
    errors.country = "Country selection is required";
    isValid = false;
  }
  if (isEmpty(formData.state)) {
    errors.state = "State selection is required";
    isValid = false;
  }
  if (isEmpty(formData.city)) {
    errors.city = "City selection is required";
    isValid = false;
  }
  if (isEmpty(formData.dateOfBirth)) {
    errors.dateOfBirth = "Date of Birth is required";
    isValid = false;
  }
  if (isEmpty(formData.gstNumber) || !isValidGST(formData.gstNumber)) {
    errors.gstNumber = "Valid 15-character GST Number is required";
    isValid = false;
  }
  if (!files.gstFile) {
    errors.gstFile = "GST File is required";
    isValid = false;
  }
  if (isEmpty(formData.panNumber) || !isValidPAN(formData.panNumber)) {
    errors.panNumber = "Valid PAN Number is required";
    isValid = false;
  }
  if (!files.panFile) {
    errors.panFile = "PAN File is required";
    isValid = false;
  }
  if (isEmpty(formData.address)) {
    errors.address = "Address is required";
    isValid = false;
  }
  // Validate useMyLocation
  if (!formData.useMyLocation.latitude || !formData.useMyLocation.longitude) {
    errors.useMyLocation = "Location (latitude and longitude) is required";
    isValid = false;
  }
  if (isEmpty(formData.currentLocation)) {
    errors.currentLocation = "Current Location is required";
    isValid = false;
  }
  if (timeAvailabilitySlot.length === 0) {
    errors.timeAvailabilitySlot = "Select at least one Time Slot";
    isValid = false;
  }
  if (daySlot.length === 0) {
    errors.daySlot = "Select at least one Day Slot";
    isValid = false;
  }
  if (!files.profilePictureFile) {
    errors.profilePictureFile = "Profile Picture is required";
    isValid = false;
  }
   if (isEmpty(formData.nameOfEmergency)) {
    errors.nameOfEmergency = "Name of Emergency is required";
    isValid = false;
  }
  if (isEmpty(formData.relationshipToAccountHolder)) {
    errors.relationshipToAccountHolder = "Relationship to Account Holder is required";
    isValid = false;
  }
  if (isEmpty(formData.emergencyPhoneNumber) || !isValidMobileNumber(formData.emergencyPhoneNumber)) {
    errors.emergencyPhoneNumber = "Valid 10-digit Emergency Phone Number is required";
    isValid = false;
  }
  if (isEmpty(formData.emergencyEmailAddress) || !isValidEmail(formData.emergencyEmailAddress)) {
    errors.emergencyEmailAddress = "Valid Email Address is required";
    isValid = false;
  }
  if (isEmpty(formData.emergencyAddress)) {
    errors.emergencyAddress = "Emergency Contact Person Address is required";
    isValid = false;
  }
  if (isEmpty(formData.toPickupLocationTime)) {
    errors.toPickupLocationTime = "To Pickup Location Time is required";
    isValid = false;
  }
  if (isEmpty(formData.toDeliveryLocationTime)) {
    errors.toDeliveryLocationTime = "To Delivery Location Time is required";
    isValid = false;
  }
  if (isEmpty(formData.maximumDeliveryCapacity)) {
    errors.maximumDeliveryCapacity = "Maximum Delivery Capacity is required";
    isValid = false;
  }
  if (isEmpty(formData.accountHoldersName)) {
    errors.accountHoldersName = "Account Holder's Name is required";
    isValid = false;
  }
  if (isEmpty(formData.typeOfAccount)) {
    errors.typeOfAccount = "Type of Account selection is required";
    isValid = false;
  }
  if (isEmpty(formData.accountNumber)) {
    errors.accountNumber = "Account Number is required";
    isValid = false;
  }
  if (isEmpty(formData.ifscCode) || !isValidIFSC(formData.ifscCode)) {
    errors.ifscCode = "Valid IFSC Code is required";
    isValid = false;
  }
  if (isEmpty(formData.branchName)) {
    errors.branchName = "Branch Name is required";
    isValid = false;
  }
  if (isEmpty(formData.gpayNumber) || !isValidMobileNumber(formData.gpayNumber)) {
    errors.gpayNumber = "Valid 10-digit Gpay Number is required";
    isValid = false;
  }
  if (isEmpty(formData.bankAddress)) {
    errors.bankAddress = "Bank Address is required";
    isValid = false;
  }
  setErrors(errors);

  return isValid;
};
const handleSubmit = async (e) => {
  e.preventDefault();
   const isValid = validateFormDeliveryVendor();
   if (!isValid) {
     return; 
   }

  const data = new FormData();
  const updatedFormData = {
    ...formData,
    timeAvailabilitySlot: JSON.stringify(timeAvailabilitySlot),
    daySlot: JSON.stringify(daySlot),
    useMyLocation: JSON.stringify(formData.useMyLocation),
  };

  for (const key in updatedFormData) {
    data.append(key, updatedFormData[key]);
  }

  try {
    for (const key in files) {
      if (files[key]) {
        data.append(key, await prepareUploadFile(files[key]));
      }
    }

    const epicxTenantId = localStorage.getItem('epicxTenantId');
    if (!epicxTenantId) {
      console.error('Tenant ID is not provided');
      return;
    }

    const response = await axios.post(`${BASE_URL}/deliveryVendor/api/deliveryVendor/${epicxTenantId}`, data, {
      headers: {
        Authorization: `Bearer ${AuthorizationToken}`,
      },
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
    });
    console.log('Response:', response.data);
    toast.success('Delivery Vendor added successfully');
    setFormData({
      deliveryVendorShopName: '',
      fullName: '',
      emailAddress: '',
      degree: '',
      primaryMobileNumber: '',
      whatsappNumber: '',
      country: '',
      state: '',
      city: '',
      dateOfBirth: '',
      gstNumber: '',
      panNumber: '',
      address: '',
      useMyLocation: { latitude: '', longitude: '' },
      currentLocation: '',
      timeAvailabilitySlot: JSON.stringify([]),
      daySlot: JSON.stringify([]),
      nameOfEmergency: '',
      relationshipToAccountHolder: '',
      emergencyPhoneNumber: '',
      emergencyEmailAddress: '',
      emergencyAddress: '',
      alternateContactPersonName: '',
      relationshipToAlternateContactPerson: '',
      alternateContactPersonNumber: '',
      alternateContactPersonAddress: '',
      toPickupLocationTime: '',
      toDeliveryLocationTime: '',
      maximumDeliveryCapacity: '',
      accountHoldersName: '',
      typeOfAccount: '',
      accountNumber: '',
      ifscCode: '',
      branchName: '',
      gpayNumber: '',
      bankAddress: ''
    });
    setFiles({
      gstFile: null,
      panFile: null,
      profilePictureFile: null
    });
    setTimeAvailabilitySlot([]);
    setDaySlot([]);
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
      toast.error(getUploadErrorMessage(error, 'Error adding delivery vendor. Please try again.'));
    }
  };
const [deliveryVendorAgentsData, setDeliveryVendorAgentsData] = useState({
  fullName: '',
  bloodGroup: '',
  address: '',
  whatsAppNumber: '',
  emergencyContactNumber: '',
  languagesKnown: [],
  aadharNumber: '',
  rcBookNumber: '',
  vehicleNumber: '',
  accountNumber: '',
  ifscCode: '',
  branchAddress: '',
  panNumber: '',
  drivingLicenseNumber: '',
  deliveryVendorName: '',   
  deliveryVendorEmail: '',  
  deliveryVendorId: '',
  useMyLocation: { latitude: '', longitude: '' },
  currentLocation: '',
});
const [uploadedFiles, setUploadedFiles] = useState({
  profileImageUpload: null,
  aadharCardFileUpload: null,
  rcBookUpload: null,
  passBookUpload: null,
  panCardUpload: null,
  drivingLicenseUpload: null,
});

const handleInputChangeAgentsAll = async (event) => {
  const selectedVendorId = event.target.selectedOptions[0]?.getAttribute('data-id');

  if (!selectedVendorId) return;

  console.log('Selected Delivery Vendor ID:', selectedVendorId);

  setLoading(true);
  try {
    const response = await axios.get(
      `${BASE_URL}/deliveryVendor/api/deliveryVendorAgents/${epicxTenantId}/deliveryVendor-agents/${selectedVendorId}`,
      {
        headers: {
            Authorization: `Bearer ${AuthorizationToken}`,
          },
        }
    );
    setAgents(response.data); 
  } catch (error) {
    console.error('Error fetching agents:', error);
    setAgents([]); 
  } finally {
    setLoading(false);
  }
};

const validateField = (name, value, files = uploadedFiles) => {
  const isEmpty = (val) => !val || val.trim() === "";
  const isValidMobileNumber = (number) => /^[0-9]{10}$/.test(number);
  const isValidAadhar = (aadhar) => /^[0-9]{12}$/.test(aadhar);
  const isValidIFSC = (ifsc) => /^[A-Z]{4}0\d{6}$/i.test(ifsc);
  const isValidPAN = (pan) => /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan);
  const isValidAccountNumber = (number) => /^\d+$/.test(number);

  let fieldError = "";
  let isFieldValid = false;

  switch (name) {
    case "personName":
      if (isEmpty(value)) fieldError = "Delivery Vendor Name is required";
      else isFieldValid = true;
      break;
    case "fullName":
      if (isEmpty(value)) fieldError = "Full Name is required";
      else isFieldValid = true;
      break;
    case "bloodGroup":
      if (isEmpty(value)) fieldError = "Blood Group is required";
      else isFieldValid = true;
      break;
    case "address":
      if (isEmpty(value)) fieldError = "Address is required";
      else isFieldValid = true;
      break;
    case "whatsAppNumber":
      if (isEmpty(value) || !isValidMobileNumber(value)) fieldError = "Valid 10-digit Primary Mobile Number is required";
      else isFieldValid = true;
      break;
    case "emergencyContactNumber":
      if (isEmpty(value) || !isValidMobileNumber(value)) fieldError = "Valid 10-digit Emergency Contact Number is required";
      else isFieldValid = true;
      break;
    case "languagesKnown":
      if (value.length === 0) fieldError = "Select at least one language";
      else isFieldValid = true;
      break;
    case "aadharNumber":
      if (isEmpty(value) || !isValidAadhar(value)) fieldError = "Valid 12-digit Aadhar Number is required";
      else isFieldValid = true;
      break;
    case "aadharCardFileUpload":
      if (!files.aadharCardFileUpload) {
        fieldError = "Aadhar Card file is required";
      } else {
        isFieldValid = true;
      }
      break;
    case "rcBookNumber":
      if (isEmpty(value)) fieldError = "RC Book Number is required";
      else isFieldValid = true;
      break;
    case "rcBookUpload":
      if (!files.rcBookUpload) {
        fieldError = "RC Book file is required";
      } else {
        isFieldValid = true;
      }
      break;
    case "vehicleNumber":
      if (isEmpty(value)) fieldError = "Vehicle Number is required";
      else isFieldValid = true;
      break;
    case "accountNumber":
      if (isEmpty(value) || !isValidAccountNumber(value)) fieldError = "Valid Account Number is required";
      else isFieldValid = true;
      break;
    case "ifscCode":
      if (isEmpty(value) || !isValidIFSC(value)) fieldError = "Valid IFSC Code (e.g., SBIN0001234) is required";
      else isFieldValid = true;
      break;
    case "branchAddress":
      if (isEmpty(value)) fieldError = "Branch Address is required";
      else isFieldValid = true;
      break;
    case "passBookUpload":
      if (!files.passBookUpload) {
        fieldError = "Pass Book file is required";
      } else {
        isFieldValid = true;
      }
      break;
    case "panNumber":
      if (isEmpty(value) || !isValidPAN(value)) fieldError = "Valid PAN Number (e.g., ABCDE1234F) is required";
      else isFieldValid = true;
      break;
    case "panCardUpload":
      if (!files.panCardUpload) {
        fieldError = "PAN Card file is required";
      } else {
        isFieldValid = true;
      }
      break;
    case "drivingLicenseNumber":
      if (isEmpty(value)) fieldError = "Driving License Number is required";
      else isFieldValid = true;
      break;
    case "drivingLicenseUpload":
      if (!files.drivingLicenseUpload) {
        fieldError = "Driving License file is required";
      } else {
        isFieldValid = true;
      }
      break;
    case "profileImageUpload":
      if (!files.profileImageUpload) {
        fieldError = "Profile Image is required";
      } else {
        isFieldValid = true;
      }
      break;
    default:
      break;
  }

  setErrors((prev) => ({ ...prev, [name]: fieldError }));
  setValidFields((prev) => ({ ...prev, [name]: isFieldValid }));
  return !fieldError;
};
const validateFormDeliveryVendorAgents = () => {
  let isValid = true;
  Object.keys(deliveryVendorAgentsData).forEach((key) => {
    if (!validateField(key, deliveryVendorAgentsData[key])) isValid = false;
  });
  ["aadharCardFileUpload", "rcBookUpload", "passBookUpload", "panCardUpload", "drivingLicenseUpload", "profileImageUpload"].forEach((key) => {
    if (!uploadedFiles[key] && !validateField(key, null)) isValid = false;
  });
  return isValid;
};

const handleInputChangeAgents = (e) => {
  if (Array.isArray(e)) {
    const newLanguages = e.map((option) => option.value);
    setDeliveryVendorAgentsData((prev) => ({
      ...prev,
      languagesKnown: newLanguages,
    }));
    validateField("languagesKnown", newLanguages);
  } else {
    const { name, value } = e.target;

    if (name === "personName") {
      const selectedOption = e.target.options[e.target.selectedIndex];
      const deliveryVendorId = selectedOption?.getAttribute("data-id");
      const deliveryVendorName = selectedOption?.getAttribute("data-name");
      const deliveryVendorEmail = selectedOption?.getAttribute("data-email");

      setDeliveryVendorAgentsData((prev) => ({
        ...prev,
        personName: value,
        deliveryVendorId,
        deliveryVendorName,
        deliveryVendorEmail,
      }));
      validateField("personName", value);
    } else {
      setDeliveryVendorAgentsData((prev) => ({
        ...prev,
        [name]: value,
      }));
      validateField(name, value);
    }
  }
};

const handleFileChangeAgents = (e) => {
  const { name, files } = e.target;
  setUploadedFiles((prev) => ({ ...prev, [name]: files[0] }));
  validateField(name, files[0]);
};

const handleRemoveFile = (fieldName) => {
  setUploadedFiles((prev) => ({ ...prev, [fieldName]: null }));
  validateField(fieldName, null);
};
const handleMapClick = (latLng) => {
  // latLng = { lat: number, lng: number }
  setAgentLocation(latLng);
};

const handleSubmitAgents = async () => {
  const isValid = validateFormDeliveryVendorAgents();
  if (!isValid) {
    toast.error("Please fill all required fields correctly");
    return;
  }

  const formData = new FormData();

  if (agentLocation) {
    formData.append(
      "useMyLocation",
      JSON.stringify({
        latitude: agentLocation.lat,
        longitude: agentLocation.lng,
      })
    );
  } else {
    formData.append(
      "useMyLocation",
      JSON.stringify({
        latitude: "",
        longitude: "",
      })
    );
  }

  Object.keys(deliveryVendorAgentsData).forEach((key) => {
    if (key === "useMyLocation") return;

    if (key === "languagesKnown" && Array.isArray(deliveryVendorAgentsData[key])) {
      formData.append(key, JSON.stringify(deliveryVendorAgentsData[key]));
    }
    else if (key === "currentLocation") {
      formData.append(key, deliveryVendorAgentsData.currentLocation || "");
    }
    else {
      formData.append(key, deliveryVendorAgentsData[key] || "");
    }
  });
  try {
    for (const key of Object.keys(uploadedFiles)) {
      if (uploadedFiles[key]) {
        formData.append(key, await prepareUploadFile(uploadedFiles[key]));
      }
    }
    const response = await axios.post(
      `${BASE_URL}/deliveryVendor/api/deliveryVendorAgents/${epicxTenantId}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${AuthorizationToken}`,
        },
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
      }
    );

    toast.success("Delivery Agent added successfully!");
    setTimeout(() => navigate('/view-delivery-vendor-agents'), 700);
    setDeliveryVendorAgentsData({
      deliveryVendorId: "",
      deliveryVendorName: "",
      deliveryVendorEmail: "",
      fullName: "",
      bloodGroup: "",
      address: "",
      whatsAppNumber: "",
      emergencyContactNumber: "",
      languagesKnown: [],
      aadharNumber: "",
      rcBookNumber: "",
      vehicleNumber: "",
      accountNumber: "",
      ifscCode: "",
      branchAddress: "",
      panNumber: "",
      drivingLicenseNumber: "",
      useMyLocation: { latitude: "", longitude: "" },
      currentLocation: "",
    });

    setUploadedFiles({});
    setAgentLocation(null);
    setAgentMapMarker(null);
    setAgentManualLat("");
    setAgentManualLng("");
    setErrors({});
    setValidFields({});
    handleClose();

  } catch (error) {
    console.error("Error adding agent:", error.response?.data || error.message);
    toast.error(getUploadErrorMessage(error, "Failed to add agent"));
  }
};

useEffect(() => {
    fetch(
        `${BASE_URL}/deliveryVendor/api/deliveryVendorAgents/${epicxTenantId}`,
        {
            headers: {
                Authorization: `Bearer ${AuthorizationToken}`,
            },
        }
    )
        .then(response => response.json())
        .then(data => setAgents(data))
        .catch(error => console.error('Error fetching data:', error));
}, []);

    const handleViewDetails = (agent) => {
      setSelectedAgent(agent);
    };
    const closeModal = () => {
      setSelectedAgent(null);
    };
  const languageOptions = [
    { value: 'English', label: 'English' },
    { value: 'Spanish', label: 'Spanish' },
    { value: 'French', label: 'French' },
    { value: 'German', label: 'German' },
    { value: 'Mandarin', label: 'Mandarin' },
    { value: 'Hindi', label: 'Hindi' }
  ];
  useEffect(() => {
    const fetchDeliveryVendors = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/deliveryVendor/api/deliveryVendor/${epicxTenantId}`,
          {
            headers: {
                Authorization: `Bearer ${AuthorizationToken}`,
              },
            }
        );
        const deliveryVendorsList = response.data || []; 
        const deliveryVendors = deliveryVendorsList.map((vendor) => ({
          _id: vendor._id,
          fullName: vendor.fullName,
          emailAddress: vendor.emailAddress,
        }));
  
        setDeliveryVendors(deliveryVendors);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching delivery vendors:", error);
        setLoading(false);
      }
    };
  
    fetchDeliveryVendors();
  }, [epicxTenantId]);

  //delivery vendor agent soft delete
  const handleDelete = async (agentId) => {
    const confirmation = window.confirm("Are you sure you want to delete this agent?");
    if (!confirmation) return; 
    try {
      const response = await axios.put(`${BASE_URL}/deliveryVendor/api/deliveryVendorAgents/delete/${epicxTenantId}/${agentId}`,
         {}, 
        {
          headers: {
              Authorization: `Bearer ${AuthorizationToken}`,
            },
          }
      );
      if (response.status === 200) {
        setAgents((prevAgents) => prevAgents.filter(agent => agent._id !== agentId));
        toast.success('Agent deleted successfully');
      } else {
        alert('Failed to delete agent');
      }
    } catch (error) {
      console.error('Error deleting agent:', error);
      alert('Error deleting agent');
    }
  };
  const toggleAgentSelection = (agentId) => {
    setSelectedAgentIds((prev) => (
      prev.includes(agentId) ? prev.filter((id) => id !== agentId) : [...prev, agentId]
    ));
  };
  const toggleAllAgents = () => {
    if (!agents?.length || selectedAgentIds.length === agents.length) {
      setSelectedAgentIds([]);
      return;
    }
    setSelectedAgentIds(agents.map((agent) => agent._id));
  };
  const handleDeleteSelectedAgents = async () => {
    if (selectedAgentIds.length === 0) return;
    const confirmation = window.confirm('Are you sure you want to delete the selected agents?');
    if (!confirmation) return;
    try {
      for (const agentId of selectedAgentIds) {
        await axios.put(
          `${BASE_URL}/deliveryVendor/api/deliveryVendorAgents/delete/${epicxTenantId}/${agentId}`,
          {},
          { headers: { Authorization: `Bearer ${AuthorizationToken}` } }
        );
      }
      setAgents((prevAgents) => prevAgents.filter((agent) => !selectedAgentIds.includes(agent._id)));
      setSelectedAgentIds([]);
      toast.success('Agent deleted successfully');
    } catch (error) {
      console.error('Error deleting agent:', error);
      alert('Error deleting agent');
    }
  };
  const handleEditSelectedAgent = () => {
    if (selectedAgentIds.length !== 1) return;
    navigate(`/update-delivery-agent/${selectedAgentIds[0]}`);
  };
  const handleExportAgents = () => {
    const rows = (selectedAgentIds.length > 0
      ? agents.filter((agent) => selectedAgentIds.includes(agent._id))
      : agents
    ).map((agent) => ({
      deliveryVendorName: agent.deliveryVendorName,
      fullName: agent.fullName,
      aadharNumber: agent.aadharNumber,
      bloodGroup: agent.bloodGroup,
      languagesKnown: Array.isArray(agent.languagesKnown) ? agent.languagesKnown.join(', ') : agent.languagesKnown,
    }));
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'DeliveryVendorAgents');
    XLSX.writeFile(wb, 'DeliveryVendorAgents_data.xlsx');
  };
  const normalizeLanguages = (langs) => {
  if (!Array.isArray(langs)) return [];

  return langs.map((lang) => {
    let value = lang;

    try {
      while (typeof value === "string" && value.startsWith('"')) {
        value = JSON.parse(value);
      }
      return value;
    } catch (e) {
      return lang;
    }
  });
};

//delivery vendor agents edit
// const handleAgentEditShow = async (agentId) => {
//   try {
//     const response = await axios.get(`${BASE_URL}/deliveryVendor/api/deliveryVendorAgents/${epicxTenantId}/${agentId}`,
//       {
//         headers: {
//             Authorization: `Bearer ${AuthorizationToken}`,
//           },
//         }
//     );
//     if (response.status === 200) {
//       setDeliveryVendorAgentsData(response.data); 
//       setUploadedFiles((prev) => ({
//         ...prev,
//         profileImageUpload: response.data.profileImageUpload
//         ? { name: 'Current Profile Image', url: response.data.profileImageUpload }: null,
//         aadharCardFileUpload : response.data.aadharCardFileUpload
//         ? { name: 'Current Aadhar Card', url: response.data.aadharCardFileUpload }: null,
//         rcBookUpload: response.data.rcBookUpload
//         ? { name: 'Current RC Book', url: response.data.rcBookUpload }: null,
//         passBookUpload: response.data.passBookUpload
//         ? { name: 'Current Pass Book', url: response.data.passBookUpload }: null,
//         drivingLicenseUpload: response.data.drivingLicenseUpload
//         ? { name: 'Current Driving License', url: response.data.drivingLicenseUpload }: null,
//       }));
//       setShowAgentEdit(true); 
//     }
//   } catch (error) {
//     console.error('Error fetching agent details:', error);
//     alert('Failed to fetch agent details');
//   }
// };
const handleAgentEditShow = async (agentId) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/deliveryVendor/api/deliveryVendorAgents/${epicxTenantId}/${agentId}`,
      {
        headers: {
          Authorization: `Bearer ${AuthorizationToken}`,
        },
      }
    );

    if (response.status === 200) {
      const agent = response.data;
      const cleanedLanguages = normalizeLanguages(agent.languagesKnown);
      setDeliveryVendorAgentsData({
        ...agent,
        languagesKnown: cleanedLanguages,
        latitude: agent?.useMyLocation?.latitude || "",
        longitude: agent?.useMyLocation?.longitude || "",
      });
      if (agent?.useMyLocation?.latitude && agent?.useMyLocation?.longitude) {
        const lat = parseFloat(agent.useMyLocation.latitude);
        const lng = parseFloat(agent.useMyLocation.longitude);

        setAgentLocation({ lat, lng });
        setAgentMapMarker({ lat, lng });
        setAgentManualLat(lat.toString());
        setAgentManualLng(lng.toString());
      } else {
        setAgentLocation(null);
        setAgentMapMarker(null);
      }
      setUploadedFiles({
        profileImageUpload: agent.profileImageUpload
          ? { name: "Current Profile Image", url: agent.profileImageUpload }
          : null,
        aadharCardFileUpload: agent.aadharCardFileUpload
          ? { name: "Current Aadhar Card", url: agent.aadharCardFileUpload }
          : null,
        rcBookUpload: agent.rcBookUpload
          ? { name: "Current RC Book", url: agent.rcBookUpload }
          : null,
        passBookUpload: agent.passBookUpload
          ? { name: "Current Pass Book", url: agent.passBookUpload }
          : null,
        drivingLicenseUpload: agent.drivingLicenseUpload
          ? { name: "Current Driving License", url: agent.drivingLicenseUpload }
          : null,
      });

      setShowAgentEdit(true);
    }
  } catch (error) {
    console.error("Error fetching agent details:", error);
    alert("Failed to fetch agent details");
  }
};

const handleSaveChanges = async () => {
  try {
    const formData = new FormData();
    formData.append('deliveryVendorId', deliveryVendorAgentsData.deliveryVendorId);
    formData.append('deliveryVendorName', deliveryVendorAgentsData.deliveryVendorName);
    formData.append('deliveryVendorEmail', deliveryVendorAgentsData.deliveryVendorEmail);
    formData.append('fullName', deliveryVendorAgentsData.fullName);
    formData.append('bloodGroup', deliveryVendorAgentsData.bloodGroup);
    formData.append('address', deliveryVendorAgentsData.address);
    formData.append('whatsAppNumber', deliveryVendorAgentsData.whatsAppNumber);
    formData.append('emergencyContactNumber', deliveryVendorAgentsData.emergencyContactNumber);

    formData.append(
      'languagesKnown',
      JSON.stringify(deliveryVendorAgentsData.languagesKnown || [])
    );

    formData.append('aadharNumber', deliveryVendorAgentsData.aadharNumber);
    formData.append('rcBookNumber', deliveryVendorAgentsData.rcBookNumber);
    formData.append('vehicleNumber', deliveryVendorAgentsData.vehicleNumber);
    formData.append('accountNumber', deliveryVendorAgentsData.accountNumber);
    formData.append('ifscCode', deliveryVendorAgentsData.ifscCode);
    formData.append('branchAddress', deliveryVendorAgentsData.branchAddress);
    formData.append('panNumber', deliveryVendorAgentsData.panNumber);
    formData.append('drivingLicenseNumber', deliveryVendorAgentsData.drivingLicenseNumber);
    formData.append(
      'useMyLocation',
      JSON.stringify({
        latitude: deliveryVendorAgentsData.latitude,
        longitude: deliveryVendorAgentsData.longitude,
      })
    );

    formData.append(
      'currentLocation',
      `${deliveryVendorAgentsData.latitude},${deliveryVendorAgentsData.longitude}`
    );

    const agentFileFields = [
      'profileImageUpload',
      'aadharCardFileUpload',
      'rcBookUpload',
      'passBookUpload',
      'panCardUpload',
      'drivingLicenseUpload',
    ];
    for (const field of agentFileFields) {
      if (uploadedFiles[field]?.file) {
        formData.append(field, await prepareUploadFile(uploadedFiles[field].file));
      }
    }

    const response = await axios.put(
      `${BASE_URL}/deliveryVendor/api/deliveryVendorAgents/${epicxTenantId}/${deliveryVendorAgentsData._id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${AuthorizationToken}`,
        },
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
      }
    );

    if (response.status === 200) {
      toast.success('Agent updated successfully');
      setShowAgentEdit(false);
      setTimeout(() => navigate('/view-delivery-vendor-agents'), 700);
      // fetchAgents();
    }
  } catch (error) {
    console.error('Error updating agent:', error);
    toast.error(getUploadErrorMessage(error, 'Failed to update agent'));
  }
};

// const handleSaveChanges = async () => {
//   try {
//     const formData = new FormData();
//     formData.append('fullName', deliveryVendorAgentsData.fullName);
//     formData.append('bloodGroup', deliveryVendorAgentsData.bloodGroup);
//     formData.append('address', deliveryVendorAgentsData.address);
//     formData.append('whatsAppNumber', deliveryVendorAgentsData.whatsAppNumber);
//     formData.append('emergencyContactNumber', deliveryVendorAgentsData.emergencyContactNumber);
//     formData.append('languagesKnown', JSON.stringify(deliveryVendorAgentsData.languagesKnown)); 
//     formData.append('aadharNumber', deliveryVendorAgentsData.aadharNumber);
//     formData.append('rcBookNumber', deliveryVendorAgentsData.rcBookNumber);
//     formData.append('vehicleNumber', deliveryVendorAgentsData.vehicleNumber);
//     formData.append('accountNumber', deliveryVendorAgentsData.accountNumber);
//     formData.append('ifscCode', deliveryVendorAgentsData.ifscCode);
//     formData.append('branchAddress', deliveryVendorAgentsData.branchAddress);
//     formData.append('panNumber', deliveryVendorAgentsData.panNumber);
//     formData.append('drivingLicenseNumber', deliveryVendorAgentsData.drivingLicenseNumber);
//     formData.append('deliveryVendorName', deliveryVendorAgentsData.deliveryVendorName);
//     formData.append('deliveryVendorEmail', deliveryVendorAgentsData.deliveryVendorEmail);
//     if (deliveryVendorAgentsData.profileImageUpload) {
//       formData.append('profileImageUpload', deliveryVendorAgentsData.profileImageUpload);
//     }
//     if (deliveryVendorAgentsData.aadharCardFileUpload) {
//       formData.append('aadharCardFileUpload', deliveryVendorAgentsData.aadharCardFileUpload);
//     }
//     if (deliveryVendorAgentsData.rcBookUpload) {
//       formData.append('rcBookUpload', deliveryVendorAgentsData.rcBookUpload);
//     }
//     if (deliveryVendorAgentsData.passBookUpload) {
//       formData.append('passBookUpload', deliveryVendorAgentsData.passBookUpload);
//     }
//     if (deliveryVendorAgentsData.panCardUpload) {
//       formData.append('panCardUpload', deliveryVendorAgentsData.panCardUpload);
//     }
//     if (deliveryVendorAgentsData.drivingLicenseUpload) {
//       formData.append('drivingLicenseUpload', deliveryVendorAgentsData.drivingLicenseUpload);
//     }
//     const response = await axios.put(
//       `${BASE_URL}/deliveryVendor/api/deliveryVendorAgents/${deliveryVendorAgentsData._id}`,
//       formData,
//       {
//         headers: {
//           'Content-Type': 'multipart/form-data', 
//           Authorization: `Bearer ${AuthorizationToken}`,
//         },
//       }
//     );
    

//     if (response.status === 200) {
//       toast.success('Agent updated successfully');
//       setShowAgentEdit(false);
//       // fetchAgents();
//     }
//   } catch (error) {
//     console.error('Error updating agent:', error);
//     alert('Failed to update agent');
//   }
// };

const updateAgentLocation = (loc) => {
  setAgentLocation(loc);
  setAgentMapMarker(loc);
  setAgentManualLat(loc.lat.toFixed(6));
  setAgentManualLng(loc.lng.toFixed(6));

  setDeliveryVendorAgentsData((prev) => ({
    ...prev,
    latitude: loc.lat.toString(),
    longitude: loc.lng.toString(),
  }));
};

const handleAgentGeocode = async () => {
  if (!agentSearchQuery.trim()) return;
  try {
    const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(agentSearchQuery)}`);
    const data = await res.json();
    if (data.length === 0) return toast.error("Location not found");
    const { lat, lon } = data[0];
    const newLoc = { lat: parseFloat(lat), lng: parseFloat(lon) };
    updateAgentLocation(newLoc);
    mapRef.current?.setView(newLoc, 16);
  } catch (err) {
    toast.error("Search failed");
  }
};
  return (
    <>
      <Sidebar/>
  <div className={isAgentsPage ? 'vendors-page agents-list-page' : 'delivery-form-page'}>
    <div className='container'>
        {isAgentFormPage ? null : isAgentsPage ? (
          <header className="vendors-hero">
            <div>
              <p className="vendors-kicker">Vendors</p>
              <h1>Delivery Vendor Agents</h1>
              <p>Browse agents for a delivery vendor, then add, view, edit, or remove them.</p>
            </div>
            <button type="button" className="vendors-primary-btn" onClick={handleShow}>
              Add Agents
            </button>
          </header>
        ) : (
        <header className="delivery-form-hero">
          <div>
            <p className="delivery-form-kicker">Vendors</p>
            <h1>Add Delivery Vendor</h1>
            <p>Enter shop, contact, documents, availability, and bank details. Required fields stay the same.</p>
          </div>
          <button type="button" className="delivery-form-back" onClick={() => navigate('/view-delivery-vendor')}>
            Back to Vendors
          </button>
        </header>
        )}
        {!isAgentsPage && !isAgentFormPage && (
        <div style={{display:'flex',flexDirection:'column',gap:'20px'}}>
        <div className="card">
          <div className="card-header bg-light d-flex justify-content-between align-items-center"
          style={{ cursor: "pointer" }}
          onClick={() => setIsCollapsed(!isCollapsed)}>
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="10" fill="green" stroke="white" strokeWidth="2" />
                            <path d="M8 12h8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <h5>Delivery Vendor Information</h5>
                        <div style={{display:'flex',justifyContent:'flex-end',width:'100%'}}>
                        {/* <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                            <circle cx="12" cy="12" r="10" fill="green" stroke="white" strokeWidth="2" />
                            <path d="M8 12l2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="2" fill="red" />
                        <path d="M8 8l8 8M16 8l-8 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg> */}
                        </div>
                    </div>
        {!isCollapsed && (
          <div className="card-body" style={{display:'flex',flexDirection:'column',gap:'10px'}}>
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="deliveryVendorShopName">Delivery Vendor Shop Name</label>
                  <span style={{ color: 'red' }}>*</span>
                  <input
                    type="text"
                    className={`form-control bg-light ${errors.deliveryVendorShopName ? 'is-invalid' : validFields.deliveryVendorShopName ? 'is-valid' : ''}`}
                    id="deliveryVendorShopName"
                    name="deliveryVendorShopName"
                    onChange={handleInputChange}
                    value={formData.deliveryVendorShopName}
                  />
                  {errors.deliveryVendorShopName && <small className="text-danger">{errors.deliveryVendorShopName}</small>}
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="fullName">Full Name</label>
                  <span style={{ color: 'red' }}>*</span>
                  <input
                    type="text"
                    className={`form-control bg-light ${errors.fullName ? 'is-invalid' : validFields.fullName ? 'is-valid' : ''}`}

                    id="fullName"
                    name="fullName"
                    onChange={handleInputChange}
                    value={formData.fullName}
                  />
                  {errors.fullName && <small className="text-danger">{errors.fullName}</small>}

                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="emailAddress">Email Address</label>
                  <span style={{ color: 'red' }}>*</span>
                  <input
                    type="email"
                    className={`form-control bg-light ${errors.emailAddress ? 'is-invalid' : validFields.emailAddress ? 'is-valid' : ''}`}
                    id="emailAddress"
                    name="emailAddress" 
                    onChange={handleInputChange}
                    value={formData.emailAddress}     
                  />
                  {errors.emailAddress && <small className="text-danger">{errors.emailAddress}</small>}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="degree">Degree</label>
                  <span style={{ color: 'red' }}>*</span>
                  <input type="text" 
                  className={`form-control bg-light ${errors.degree ? 'is-invalid' : validFields.degree ? 'is-valid' : ''}`}
                   id="degree"
                   name="degree"
                   onChange={handleInputChange}
                   value={formData.degree}  
                  />
                  {errors.degree && <small className="text-danger">{errors.degree}</small>}
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="primaryMobileNumber">Primary Mobile Number</label>
                  <span style={{ color: 'red' }}>*</span>
                  <input type="text"
                  className={`form-control bg-light ${errors.primaryMobileNumber ? 'is-invalid' : validFields.primaryMobileNumber ? 'is-valid' : ''}`}
                   id="primaryMobileNumber"
                    name="primaryMobileNumber"
                    onChange={handleInputChange}
                   value={formData.primaryMobileNumber}
                   maxLength="10"
                   pattern="\d*"
                   inputMode="numeric"  
                   />
                  {errors.primaryMobileNumber && <small className="text-danger">{errors.primaryMobileNumber}</small>}

                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="whatsappNumber">Primary Mobile Number</label>
                  <span style={{ color: 'red' }}>*</span>
                  <input type="text" 
                  className={`form-control bg-light ${errors.whatsappNumber ? 'is-invalid' : validFields.whatsappNumber ? 'is-valid' : ''}`}
                   id="whatsappNumber"
                   name="whatsappNumber"
                   onChange={handleInputChange}
                   value={formData.whatsappNumber} 
                   maxLength="10"
                   pattern="\d*"
                   inputMode="numeric" 
                  />
                  {errors.whatsappNumber && <small className="text-danger">{errors.whatsappNumber}</small>}
                </div>
              </div>
            </div>
            <div className='row'>
            <div className='col-md-4'>
              <label htmlFor='country'>Country</label>
              <span style={{ color: 'red' }}>*</span>
              <select id='country' 
              className={`form-control bg-light ${errors.country ? 'is-invalid' : validFields.country ? 'is-valid' : ''}`}

               style={{color:'gray'}}
              name="country"
              onChange={handleInputChange}
              value={formData.country} 
             >
                <option value=''>Select Country</option>
                <option value='India'>India</option>
              </select>
              {errors.country && <small className="text-danger">{errors.country}</small>}

            </div>
            <div className='col-md-4'>
              <label htmlFor='state'>State</label>
              <span style={{ color: 'red' }}>*</span>
              <select id='state' 
              className={`form-control bg-light ${errors.state ? 'is-invalid' : validFields.state ? 'is-valid' : ''}`}
              style={{color:'gray'}}  name="state"
               onChange={handleInputChange}
               value={formData.state} 
             
             >
                <option value=''>Select State</option>
                <option value='Tamil Nadu'>Tamil Nadu</option>
              </select>
              {errors.state && <small className="text-danger">{errors.state}</small>}

            </div>
            <div className='col-md-4'>
              <label htmlFor='city'>City</label>
              <span style={{ color: 'red' }}>*</span>
              <select id='city' 
              className={`form-control bg-light ${errors.city ? 'is-invalid' : validFields.city ? 'is-valid' : ''}`}
               style={{color:'gray'}}
              name="city"
              onChange={handleInputChange}
              value={formData.city} 
             >
                <option value=''>Select City</option>
                <option value='Rajapalayam'>Rajapalayam</option>
                <option value='Sankarankovil'>Sankarankovil</option>
              </select>
              {errors.city && <small className="text-danger">{errors.city}</small>}
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="dateOfBirth">Date of Birth</label>
                <span style={{ color: 'red' }}>*</span>
                <input type="date"
              className={`form-control bg-light ${errors.dateOfBirth ? 'is-invalid' : validFields.dateOfBirth ? 'is-valid' : ''}`}
                 id="dateOfBirth" name="dateOfBirth" 
                 onChange={handleInputChange}
                 value={formData.dateOfBirth} 
                />
              {errors.dateOfBirth && <small className="text-danger">{errors.dateOfBirth}</small>}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="gstNumber">GST Number</label>
                <span style={{ color: 'red' }}>*</span>
                <input type="text" 
              className={`form-control bg-light ${errors.gstNumber ? 'is-invalid' : validFields.gstNumber ? 'is-valid' : ''}`}
                id="gstNumber" 
                name="gstNumber"
                onChange={handleInputChange}
                value={formData.gstNumber}
                maxLength="15"
               />
              {errors.gstNumber && <small className="text-danger">{errors.gstNumber}</small>}
              </div>
            </div>
            <div className="col-md-4">
        <label>GST File</label>
        <span style={{ color: 'red' }}>*</span>
        <label htmlFor="file-upload-button">
          <Input
            accept="/*" 
            id="file-upload-button"
            type="file"
            name="gstFile"
            onChange={handleFileChange}
            style={{ display: 'none' }} 
          />
          <Button
            variant="contained"
            component="span"
            endIcon={
              files.gstFile ? (
                <>
                  <span style={{ fontSize: '15px' }}>{files.gstFile.name}</span>
                  <img 
                    src={removeIcon} 
                    alt="Remove File Icon"
                    style={{ width: '20px', height: '20px', cursor: 'pointer' }} 
                    onClick={() => handleFileRemove('gstFile')}
                  />
                </>
              ) : (
                <img src={uploadicon} alt="Upload Icon" style={{ width: '20px', height: '20px' }} />
              )
            }
            style={{ backgroundColor: '#00B982', color: 'white', width: '385px',height:'35px'}}
          >
            {files.gstFile ? '' : 'Upload'} 
          </Button>
          {errors.gstFile && <small className="text-danger">{errors.gstFile}</small>}

        </label>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="panNumber">PAN Number</label>
                <span style={{ color: 'red' }}>*</span>
                <input type="text" 
              className={`form-control bg-light ${errors.panNumber ? 'is-invalid' : validFields.panNumber ? 'is-valid' : ''}`}
                id="panNumber" name="panNumber"
                onChange={handleInputChange}
                value={formData.panNumber}
               />
              {errors.panNumber && <small className="text-danger">{errors.panNumber}</small>}
              </div>
            </div>
            <div className="col-md-4">
        <label>PAN File Upload</label>
        <span style={{ color: 'red' }}>*</span>
        <label htmlFor="pan-file-upload-button">
          <Input
            accept="/*" 
            id="pan-file-upload-button"
            type="file"
            name="panFile"
            onChange={handleFileChange}
            style={{ display: 'none' }} 
          />
          <Button
            variant="contained"
            component="span"
            endIcon={
              files.panFile ? (
                <>
                  <span style={{ fontSize: '15px' }}>{files.panFile.name}</span>
                  <img 
                    src={removeIcon} 
                    alt="Remove File Icon"
                    style={{ width: '20px', height: '20px', cursor: 'pointer' }} 
                    onClick={() => handleFileRemove('panFile')}
                  />
                </>
              ) : (
                <img src={uploadicon} alt="Upload Icon" style={{ width: '20px', height: '20px' }} />
              )
            }
            style={{ backgroundColor: '#00B982', color: 'white', width: '385px',height:'35px' }}
          >
            {files.panFile ? '' : 'Upload'} 
          </Button>
          {errors.panFile && <small className="text-danger">{errors.panFile}</small>}
        </label>
      </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="address">Address</label>
                <span style={{ color: 'red' }}>*</span>
                <textarea
              className={`form-control bg-light ${errors.address ? 'is-invalid' : validFields.address ? 'is-valid' : ''}`}
                  id="address" name="address" rows="2" 
                onChange={handleInputChange}
                value={formData.address}
               ></textarea>
              {errors.address && <small className="text-danger">{errors.address}</small>}
              </div>
            </div>
          </div>
          <div className='row'>
    <div className='col-md-4'>
  <label htmlFor='useMyLocation'>Use My Location</label>
  <span style={{ color: 'red' }}>*</span>
  <button
    type='button'
    className={`btn d-flex justify-content-between align-items-center 
      ${errors.useMyLocation ? 'border-danger' : validFields.useMyLocation ? 'border-success' : ''}`}
    style={{ backgroundColor: '#00B982', color: 'white', width: '100%' }}
    onClick={() => setIsMapOpen(true)}
  >
    <span>
      {selectedLocation
        ? `Picked: ${selectedLocation.lat.toFixed(4)}, ${selectedLocation.lng.toFixed(4)}`
        : 'Live Location'}
    </span>
    <img src={location} alt="location" style={{ width: '20px', height: '20px' }} />
  </button>

  {selectedLocation && (
    <button
      type='button'
      className='btn btn-sm btn-link text-danger mt-1 p-0'
      onClick={() => {
        setSelectedLocation(null);
        setMapMarker(null);
        setManualLat('');
        setManualLng('');
        setFormData(prev => ({
          ...prev,
          useMyLocation: { latitude: '', longitude: '' }
        }));
        setIsLocationPicked(false);
        setErrors(prev => ({ ...prev, useMyLocation: 'Location is required' }));
      }}
    >
      Clear Location
    </button>
  )}

  {errors.useMyLocation && <small className="text-danger">{errors.useMyLocation}</small>}
</div>

            <div className='col-md-8'>
              <label htmlFor='currentLocation'>Current Location</label>
              <span style={{ color: 'red' }}>*</span>
              <input 
                type='text' 
                id='currentLocation' 
              className={`form-control bg-light ${errors.currentLocation ? 'is-invalid' : validFields.currentLocation ? 'is-valid' : ''}`}
                name='currentLocation'
                onChange={handleInputChange}
                value={formData.currentLocation}
              />
      {errors.currentLocation && <small className="text-danger">{errors.currentLocation}</small>}
            </div>
          </div>
          <div className="row">
                <div className="col-md-12 buttonsgap">
                    <label>Time Availability Slot</label>
                    <span style={{ color: 'red' }}>*</span>
                    <div className="btn-group" role="group" aria-label="Time Availability Slot">
                    {['6:00 AM - 10:00 PM', '11:00 AM - 8:00 PM', '9:00 AM - 9:00 PM', '9:30 AM - 10:00 PM', '10:00 AM - 10:00 PM','12:00 AM - 11:59 PM'].map(time => (
                            <button
                                key={time}
                                type="button"
                                className={`bg-light btn btn-outline-secondary slot-btn ${timeAvailabilitySlot.includes(time) ? 'active' : ''}`}
                                onClick={() => handleButtonClick(time)}
                                style={{ borderRadius: '4px' }}
                            >
                                {time}
                            </button>
                        ))}
                    </div>
                </div>
            {errors.timeAvailabilitySlot && <small className="text-danger">{errors.timeAvailabilitySlot}</small>}

          </div>
          <div className="row">
                <div className="col-md-8 buttonsgap">
                    <label>Day Slot</label>
                    <span style={{ color: 'red' }}>*</span>
                    <div className="btn-group" role="group" aria-label="Day Slot">
                        {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map(day => (
                            <button
                                key={day}
                                type="button"
                                className={`bg-light btn btn-outline-secondary slot-btn ${daySlot.includes(day) ? 'active' : ''}`}
                                onClick={() => handleDaysButtonClick(day)}
                                style={{ borderRadius: '4px' }}
                            >
                                {day}
                            </button>
                        ))}
                    </div>
      {errors.daySlot && <small className="text-danger">{errors.daySlot}</small>}
                </div>
                <div className="col-md-4">
        <label>Your Profile Picture</label>
        <span style={{ color: 'red' }}>*</span>
        <label htmlFor="profile-picture-upload-button">
          <Input
            accept="/*" 
            id="profile-picture-upload-button"
            type="file"
            name="profilePictureFile"
            onChange={handleFileChange}
            style={{ display: 'none' }} 
          />
          <Button
            variant="contained"
            component="span"
            endIcon={
              files.profilePictureFile ? (
                <>
                  <span style={{ fontSize: '15px' }}>{files.profilePictureFile.name}</span>
                  <img 
                    src={removeIcon}
                    alt="Remove File Icon"
                    style={{ width: '20px', height: '20px', cursor: 'pointer' }} 
                    onClick={() => handleFileRemove('profilePictureFile')}
                  />
                </>
              ) : (
                <img src={uploadicon} alt="Upload Icon" style={{ width: '20px', height: '20px' }} />
              )
            }
            style={{ backgroundColor: '#00B982', color: 'white', width: '385px',height:'35px' }}
          >
            {files.profilePictureFile ? '' : 'Upload'} 
          </Button>
      {errors.profilePictureFile && <small className="text-danger">{errors.profilePictureFile}</small>}
        </label>
                </div>
          </div>
        </div>
         )}
      </div>
      <div className="card">
        <div className="card-header bg-light d-flex justify-content-between align-items-center">
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="10" fill="green" stroke="white" strokeWidth="2" />
                            <path d="M8 12h8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <h5>Emergency Details</h5>
                        <div style={{display:'flex',justifyContent:'flex-end',width:'100%'}}>
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                            <circle cx="12" cy="12" r="10" fill="green" stroke="white" strokeWidth="2" />
                            <path d="M8 12l2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="2" fill="red" />
                        <path d="M8 8l8 8M16 8l-8 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        </div>
                    </div>
        <div className="card-body" style={{display:'flex',flexDirection:'column',gap:'10px'}}>
          <div className="row">
            <div className="col-md-4 mb-3">
              <label htmlFor="nameOfEmergency">Name of Emergency</label>
              <span style={{ color: 'red' }}>*</span>
              <input type="text" id="nameOfEmergency" 
              className={`form-control bg-light ${errors.nameOfEmergency ? 'is-invalid' : validFields.nameOfEmergency ? 'is-valid' : ''}`}
               name='nameOfEmergency'
               onChange={handleInputChange}
               value={formData.nameOfEmergency}
              />
      {errors.nameOfEmergency && <small className="text-danger">{errors.nameOfEmergency}</small>}
            </div>
            <div className="col-md-4 mb-3">
              <label htmlFor="relationshipToAccountHolder">Relationship to Account Holder</label>
              <span style={{ color: 'red' }}>*</span>
              <input type="text" id="relationshipToAccountHolder"
              className={`form-control bg-light ${errors.relationshipToAccountHolder ? 'is-invalid' : validFields.relationshipToAccountHolder ? 'is-valid' : ''}`}
               name='relationshipToAccountHolder'
               onChange={handleInputChange}
               value={formData.relationshipToAccountHolder}
             
              />
      {errors.relationshipToAccountHolder && <small className="text-danger">{errors.relationshipToAccountHolder}</small>}
            </div>
            <div className="col-md-4 mb-3">
              <label htmlFor="emergencyPhoneNumber">Emergency Phone Number</label>
              <span style={{ color: 'red' }}>*</span>
              <input type="text" id="emergencyPhoneNumber" 
              className={`form-control bg-light ${errors.emergencyPhoneNumber ? 'is-invalid' : validFields.emergencyPhoneNumber ? 'is-valid' : ''}`}
               name='emergencyPhoneNumber'
               onChange={handleInputChange}
               value={formData.emergencyPhoneNumber}
               maxLength="10"
               pattern="\d*"
               inputMode="numeric"
             
              />
      {errors.emergencyPhoneNumber && <small className="text-danger">{errors.emergencyPhoneNumber}</small>}

            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="emergencyEmailAddress">Emergency Email Address</label>
                <span style={{ color: 'red' }}>*</span>
                <input
                  type="email"
              className={`form-control bg-light ${errors.emergencyEmailAddress ? 'is-invalid' : validFields.emergencyEmailAddress ? 'is-valid' : ''}`}
                  id="emergencyEmailAddress"
                  name='emergencyEmailAddress'
                  onChange={handleInputChange}
                  value={formData.emergencyEmailAddress}
                 
                />
      {errors.emergencyEmailAddress && <small className="text-danger">{errors.emergencyEmailAddress}</small>}

              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="alternateContactPersonName">Alternate Contact Person Name</label>
                <input
                  type="text"
                  className="form-control bg-light"
                  id="alternateContactPersonName"
                  name='alternateContactPersonName'
                  onChange={handleInputChange}
                  value={formData.alternateContactPersonName}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="relationshipToAlternateContactPerson">Relationship to Alternate Contact Person</label>
                <input
                  type="text"
                  className="form-control bg-light"
                  id="relationshipToAlternateContactPerson"
                  name='relationshipToAlternateContactPerson'
                  onChange={handleInputChange}
                  value={formData.relationshipToAlternateContactPerson}
                />
              </div>
            </div>
          </div>
          <div className="row">
          <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="alternateContactPersonNumber">Alternate Contact Person Number</label>
                <input type="text" id="alternateContactPersonNumber" className="form-control bg-light" 
                 name='alternateContactPersonNumber'
                 onChange={handleInputChange}
                 value={formData.alternateContactPersonNumber}
                 maxLength="10"
                 pattern="\d*"
                 inputMode="numeric"
               
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="emergencyAddress">Emergency Contact Person Address</label>
                <span style={{ color: 'red' }}>*</span>
                <textarea id="emergencyAddress" 
              className={`form-control bg-light ${errors.emergencyAddress ? 'is-invalid' : validFields.emergencyAddress ? 'is-valid' : ''}`}
                rows="2"
                 name='emergencyAddress'
                 onChange={handleInputChange}
                 value={formData.emergencyAddress}
              
                ></textarea>
      {errors.emergencyAddress && <small className="text-danger">{errors.emergencyAddress}</small>}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="alternateContactPersonAddress">Alternate Contact Person Address</label>
                <textarea id="alternateContactPersonAddress" className="form-control bg-light" rows="2"
                 name='alternateContactPersonAddress'
                 onChange={handleInputChange}
                 value={formData.alternateContactPersonAddress}
               
                ></textarea>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div className="card">
        <div className="card-header bg-light d-flex justify-content-between align-items-center">
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="10" fill="green" stroke="white" strokeWidth="2" />
                            <path d="M8 12h8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <h5>TAT Schedule</h5>
                        <div style={{display:'flex',justifyContent:'flex-end',width:'100%'}}>
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                            <circle cx="12" cy="12" r="10" fill="green" stroke="white" strokeWidth="2" />
                            <path d="M8 12l2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="2" fill="red" />
                        <path d="M8 8l8 8M16 8l-8 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        </div>
                    </div>
        <div className="card-body" style={{display:'flex',flexDirection:'column',gap:'10px'}}>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="toPickupLocationTime">To Pickup Location Time</label>
                <span style={{ color: 'red' }}>*</span>
                <input type="text" 
              className={`form-control bg-light ${errors.toPickupLocationTime ? 'is-invalid' : validFields.toPickupLocationTime ? 'is-valid' : ''}`}
                id="toPickupLocationTime" 
                name='toPickupLocationTime'
                onChange={handleInputChange}
                 value={formData.toPickupLocationTime}
               
               />
      {errors.toPickupLocationTime && <small className="text-danger">{errors.toPickupLocationTime}</small>}

              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="toDeliveryLocationTime">To Delivery Location Time</label>
                <span style={{ color: 'red' }}>*</span>
                <input type="text" 
              className={`form-control bg-light ${errors.toDeliveryLocationTime ? 'is-invalid' : validFields.toDeliveryLocationTime ? 'is-valid' : ''}`}

                 id="toDeliveryLocationTime" 
                 name='toDeliveryLocationTime'
                 onChange={handleInputChange}
                 value={formData.toDeliveryLocationTime}
               
                />
      {errors.toDeliveryLocationTime && <small className="text-danger">{errors.toDeliveryLocationTime}</small>}

              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="maximumDeliveryCapacity">Maximum Delivery Capacity</label>
                <span style={{ color: 'red' }}>*</span>
                <input type="text"
              className={`form-control bg-light ${errors.maximumDeliveryCapacity ? 'is-invalid' : validFields.maximumDeliveryCapacity ? 'is-valid' : ''}`}

                 id="maximumDeliveryCapacity"
                 name='maximumDeliveryCapacity'
                 onChange={handleInputChange}
                 value={formData.maximumDeliveryCapacity}
                />
               {errors.maximumDeliveryCapacity && <small className="text-danger">{errors.maximumDeliveryCapacity}</small>}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header bg-light d-flex justify-content-between align-items-center">
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="10" fill="green" stroke="white" strokeWidth="2" />
                            <path d="M8 12h8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <h5>Bank Account Details</h5>
                        <div style={{display:'flex',justifyContent:'flex-end',width:'100%'}}>
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                            <circle cx="12" cy="12" r="10" fill="green" stroke="white" strokeWidth="2" />
                            <path d="M8 12l2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="2" fill="red" />
                        <path d="M8 8l8 8M16 8l-8 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        </div>
                    </div>
        <div className="card-body" style={{display:'flex',flexDirection:'column',gap:'10px'}}>
        <div className="row">
        <div className="col-md-4 mb-3">
          <label htmlFor="accountHoldersName" className="form-label">Account Holder's Name</label>
          <span style={{ color: 'red' }}>*</span>
          <input 
            type="text" 
            className={`form-control bg-light ${errors.accountHoldersName ? 'is-invalid' : validFields.accountHoldersName ? 'is-valid' : ''}`}
            id="accountHoldersName"
            name='accountHoldersName'
            onChange={handleInputChange}
            value={formData.accountHoldersName}
          />
      {errors.accountHoldersName && <small className="text-danger">{errors.accountHoldersName}</small>}
        </div>
        <div className="col-md-4 mb-3" style={{ display: 'flex', flexDirection: 'column' }}>
        <label className="form-label">Type Of Account <span style={{ color: 'red' }}>*</span></label>
        <div 
        className={`btn-group bg-light ${errors.typeOfAccount ? 'is-invalid' : validFields.typeOfAccount ? 'is-valid' : ''}`}
        role="group" aria-label="Type of Account">
          <button
            type="button"
            className={`btn btn-outline-secondary ${formData.typeOfAccount === 'Current' ? 'active' : ''}`}
            onClick={() => handleAccountTypeChange('Current')}
          >
            Current
          </button>
          <button
            type="button"
            className={`btn btn-outline-secondary ${formData.typeOfAccount === 'Savings' ? 'active' : ''}`}
            onClick={() => handleAccountTypeChange('Savings')}
          >
            Savings
          </button>

        </div>
      {errors.typeOfAccount && <small className="text-danger">{errors.typeOfAccount}</small>}

      </div>
        <div className="col-md-4 mb-3">
          <label htmlFor="accountNumber" className="form-label">Account Number</label>
          <span style={{ color: 'red' }}>*</span>
                <span style={{ color: 'red' }}>*</span>
          <input 
            type="text" 
            className={`form-control bg-light ${errors.accountNumber ? 'is-invalid' : validFields.accountNumber ? 'is-valid' : ''}`}
            id="accountNumber" 
            name='accountNumber'
            onChange={handleInputChange}
            value={formData.accountNumber}
          />
      {errors.accountNumber && <small className="text-danger">{errors.accountNumber}</small>}
        </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label htmlFor="ifscCode">IFSC Code</label>
              <span style={{ color: 'red' }}>*</span>
              <input type="text"
            className={`form-control bg-light ${errors.ifscCode ? 'is-invalid' : validFields.ifscCode ? 'is-valid' : ''}`}

                id="ifscCode"
                name='ifscCode'
                onChange={handleInputChange}
                value={formData.ifscCode}
               />
      {errors.ifscCode && <small className="text-danger">{errors.ifscCode}</small>}
               {/* {formData.ifscCode && !/^[A-Za-z]{4}\d{7}$/.test(formData.ifscCode) && (
                <div className="text-danger">
                  Please enter a valid IFSC Code (e.g., ABCD1234567)
                </div>
              )} */}
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label htmlFor="branchName">Branch Name</label>
              <span style={{ color: 'red' }}>*</span>
              <input type="text"
            className={`form-control bg-light ${errors.branchName ? 'is-invalid' : validFields.branchName ? 'is-valid' : ''}`}
               id="branchName"
               name='branchName'
               onChange={handleInputChange}
                value={formData.branchName}
              />
      {errors.branchName && <small className="text-danger">{errors.branchName}</small>}

            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label htmlFor="gpayNumber">Gpay Number</label>
              <span style={{ color: 'red' }}>*</span>
              <input type="text"
            className={`form-control bg-light ${errors.gpayNumber ? 'is-invalid' : validFields.gpayNumber ? 'is-valid' : ''}`}
               id="gpayNumber"
               name='gpayNumber'
               onChange={handleInputChange}
               value={formData.gpayNumber}
               maxLength="10"
               pattern="\d*"
               inputMode="numeric"
              />
      {errors.gpayNumber && <small className="text-danger">{errors.gpayNumber}</small>}

            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label htmlFor="bankAddress">Bank Address</label>
              <span style={{ color: 'red' }}>*</span>
              <input type="text" 
            className={`form-control bg-light ${errors.bankAddress ? 'is-invalid' : validFields.bankAddress ? 'is-valid' : ''}`}
              id="bankAddress" placeholder="Enter Bank Address" 
                name='bankAddress'
                onChange={handleInputChange}
                value={formData.bankAddress}
               />
      {errors.bankAddress && <small className="text-danger">{errors.bankAddress}</small>}

            </div>
          </div>
        </div>
        </div>
      </div>
        </div>
        )}
      {isAgentsPage && (
      <>
        <section className="vendors-toolbar" aria-label="Agent filters">
          <div className="vendors-search" style={{ width: 'min(420px, 50vw)' }}>
            <select
              className="form-select"
              name="personName"
              onChange={handleInputChangeAgentsAll}
              disabled={loading}
              aria-label="Select delivery vendor"
            >
              <option value="">Select Delivery Vendor Name</option>
              {deliveryVendors.map((deliveryVendor, index) => (
                <option
                  key={index}
                  value={deliveryVendor.fullName}
                  data-id={deliveryVendor._id}
                  data-name={deliveryVendor.fullName}
                  data-email={deliveryVendor.emailAddress}
                >
                  {deliveryVendor.fullName} ({deliveryVendor.emailAddress})
                </option>
              ))}
            </select>
          </div>
          <Dropdown>
            <Dropdown.Toggle className="vendors-action-btn">
              Actions
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={handleDeleteSelectedAgents} disabled={selectedAgentIds.length === 0}>
                <FaTrashAlt className="me-2" /> Delete
              </Dropdown.Item>
              <Dropdown.Item onClick={handleExportAgents}>
                <FaFileExport className="me-2" /> Export
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </section>
      <div className="vendors-card">
        <div className="vendors-card-head">
          <div>
            <h2>All Delivery Vendor Agents</h2>
            <p>Select a delivery vendor to load that vendor's agents.</p>
          </div>
          <span className="vendors-count">{agents?.length || 0} {agents?.length === 1 ? 'agent' : 'agents'}</span>
        </div>
        <div className="vendors-card-body">
          <div className="vendors-table-wrap no-scroll">
      <table className="vendors-table agents-table vendors-table-plain">
        <colgroup>
          <col className="col-check" />
          <col className="col-vendor" />
          <col className="col-agent" />
          <col className="col-doc-name" />
          <col className="col-doc-number" />
          <col className="col-upload" />
          <col className="col-blood" />
          <col className="col-action" />
        </colgroup>
        <thead>
          <tr>
            <th className="vendors-check-cell">
              <input
                className="vendors-checkbox"
                type="checkbox"
                aria-label="Select all agents"
                checked={agents.length > 0 && selectedAgentIds.length === agents.length}
                onChange={toggleAllAgents}
              />
            </th>
            <th className="vendors-sticky-name">Delivery Vendor Name</th>
            <th>Agent Name</th>
            <th>Document Name</th>
            <th>Document Number</th>
            <th>Document Upload</th>
            <th>Blood Group</th>
            <th className="vendors-action-cell">Action</th>
          </tr>
        </thead>
        <tbody>
          {agents && agents.length > 0 ? (
            agents.map((agent) => (
              <tr key={agent._id} className={selectedAgentIds.includes(agent._id) ? 'is-selected' : ''}>
                <td className="vendors-check-cell">
                  <input
                    className="vendors-checkbox"
                    type="checkbox"
                    aria-label={`Select ${agent.fullName}`}
                    checked={selectedAgentIds.includes(agent._id)}
                    onChange={() => toggleAgentSelection(agent._id)}
                  />
                </td>
                <td className="vendors-sticky-name"><span className="vendor-name">{agent.deliveryVendorName}</span></td>
                <td>{agent.fullName}</td>
                <td>Aadhar Card</td>
                <td>{agent.aadharNumber}</td>
                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                  {agent.aadharCardFileUpload ? (
                    <a
                      href={agent.aadharCardFileUpload}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="vendors-icon-btn vendors-icon-btn--doc"
                      title="View document"
                      aria-label={`View document for ${agent.fullName}`}
                    >
                      <FaFileAlt aria-hidden="true" />
                    </a>
                  ) : (
                    <span className="vendors-doc-na">—</span>
                  )}
                </td>
                <td>{agent.bloodGroup}</td>
                <td className="vendors-action-cell">
                  <div className="vendors-action-group">
                    <button type="button" className="vendors-icon-btn vendors-icon-btn--view" aria-label={`View details for ${agent.fullName}`} title="View details" onClick={() => handleViewDetails(agent)}>
                      <FaEye aria-hidden="true" />
                    </button>
                    <button type="button" className="vendors-icon-btn vendors-icon-btn--edit" aria-label={`Edit ${agent.fullName}`} title="Edit agent" onClick={() => navigate(`/update-delivery-agent/${agent._id}`)}>
                      <FaEdit aria-hidden="true" />
                    </button>
                  </div>
                </td>

              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9" style={{ textAlign: 'center', color: 'gray' }}>
                No Delivery Agents found for the given Delivery Vendor
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <Modal show={Boolean(selectedAgent)} onHide={closeModal} size="lg" centered dialogClassName="vendor-details-modal">
        <Modal.Header closeButton>
          <Modal.Title>Agent Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedAgent && (
            <div className="vendor-details-content">
              <div className="vendor-details-title">
                {selectedAgent.profileImageUpload ? (
                  <img className="vendor-details-photo" src={selectedAgent.profileImageUpload} alt={selectedAgent.fullName || 'Profile'} />
                ) : (
                  <span>{(selectedAgent.fullName || 'A').charAt(0)}</span>
                )}
                <div>
                  <small>Delivery agent</small>
                  <h3>{selectedAgent.fullName || 'N/A'}</h3>
                  <p>{selectedAgent.deliveryVendorName || 'Vendor not added'}</p>
                </div>
              </div>
              <div className="vendor-details-grid">
                <div><span>Primary Mobile Number</span><strong>{selectedAgent.whatsAppNumber || 'N/A'}</strong></div>
                <div><span>Emergency Contact</span><strong>{selectedAgent.emergencyContactNumber || 'N/A'}</strong></div>
                <div><span>Blood Group</span><strong>{selectedAgent.bloodGroup || 'N/A'}</strong></div>
                <div>
                  <span>Languages Known</span>
                  <strong>
                    {Array.isArray(selectedAgent.languagesKnown) && selectedAgent.languagesKnown.length
                      ? selectedAgent.languagesKnown.join(', ')
                      : selectedAgent.languagesKnown || 'N/A'}
                  </strong>
                </div>
                <div className="details-wide"><span>Address</span><strong>{selectedAgent.address || 'N/A'}</strong></div>
              </div>
              <section className="vendor-details-section">
                <h4>Documents</h4>
                <div className="vendor-detail-chips">
                  {selectedAgent.aadharCardFileUpload && (
                    <a href={selectedAgent.aadharCardFileUpload} target="_blank" rel="noopener noreferrer" className="vendors-view-btn">
                      <FaEye aria-hidden="true" /> View Aadhar Card
                    </a>
                  )}
                  {selectedAgent.rcBookUpload && (
                    <a href={selectedAgent.rcBookUpload} target="_blank" rel="noopener noreferrer" className="vendors-view-btn">
                      <FaEye aria-hidden="true" /> View RC Book
                    </a>
                  )}
                  {selectedAgent.passBookUpload && (
                    <a href={selectedAgent.passBookUpload} target="_blank" rel="noopener noreferrer" className="vendors-view-btn">
                      <FaEye aria-hidden="true" /> View Pass Book
                    </a>
                  )}
                  {selectedAgent.panCardUpload && (
                    <a href={selectedAgent.panCardUpload} target="_blank" rel="noopener noreferrer" className="vendors-view-btn">
                      <FaEye aria-hidden="true" /> View PAN Card
                    </a>
                  )}
                  {selectedAgent.drivingLicenseUpload && (
                    <a href={selectedAgent.drivingLicenseUpload} target="_blank" rel="noopener noreferrer" className="vendors-view-btn">
                      <FaEye aria-hidden="true" /> View Driving License
                    </a>
                  )}
                </div>
              </section>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="vendors-modal-close" onClick={closeModal}>Close</button>
        </Modal.Footer>
      </Modal>
          </div>
        </div>
        <div className="vendors-card-footer">
          <span className="vendors-page-summary">
            {agents?.length > 0 ? `Showing 1–${agents.length} of ${agents.length}` : 'Showing 0 agents'}
          </span>
        </div>
      </div>
      </>
      )}
{isAddAgentPage && (
  <>
    <header className="delivery-form-hero">
      <div>
        <p className="delivery-form-kicker">Vendors</p>
        <h1>Add Agent</h1>
        <p>Enter the delivery agent details. Required fields stay the same.</p>
      </div>
      <button type="button" className="delivery-form-back" onClick={() => navigate('/view-delivery-vendor-agents')}>
        Back to Agents
      </button>
    </header>
    <div className="card">
      <div className="card-header"><h5>Agent Information</h5></div>
      <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
<div className={`modal fade vendor-map-modal ${isAgentMapOpen ? 'show d-block' : ''}`} tabIndex="-1">
  <div className="modal-dialog modal-lg modal-dialog-centered vendor-map-dialog">
    <div className="modal-content vendor-map-content">
      <div className="modal-header vendor-map-header">
        <div>
          <p>Vendors</p>
          <h5 className="modal-title">Select location</h5>
        </div>
        <button type="button" className="btn-close" onClick={() => setIsAgentMapOpen(false)}></button>
      </div>
      <div className="modal-body vendor-map-body">
        <p className="vendor-map-hint">Search an address, enter coordinates, or click the map to drop a pin.</p>
        <div className="vendor-map-search">
          <input
            className="form-control"
            placeholder="Search location..."
            value={agentSearchQuery}
            onChange={(e) => setAgentSearchQuery(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleAgentGeocode()}
          />
          <button type="button" className="vendor-map-search-btn" onClick={handleAgentGeocode}>
            Search
          </button>
        </div>

        <div className="vendor-map-coords">
          <div>
            <label>Latitude</label>
            <input type="number" step="any" className="form-control" value={agentManualLat}
              onChange={(e) => {
                const v = e.target.value;
                setAgentManualLat(v);
                if (v && agentManualLng) updateAgentLocation({ lat: parseFloat(v), lng: parseFloat(agentManualLng) });
              }} />
          </div>
          <div>
            <label>Longitude</label>
            <input type="number" step="any" className="form-control" value={agentManualLng}
              onChange={(e) => {
                const v = e.target.value;
                setAgentManualLng(v);
                if (v && agentManualLat) updateAgentLocation({ lat: parseFloat(agentManualLat), lng: parseFloat(v) });
              }} />
          </div>
        </div>

        <div className="vendor-map-frame">
          <MapContainer center={[11.0168, 76.9558]} zoom={13} style={{ height: "100%", width: "100%" }} ref={mapRef}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <MapClickHandler onSelect={updateAgentLocation} />
            {agentMapMarker && <Marker position={[agentMapMarker.lat, agentMapMarker.lng]} />}
          </MapContainer>
        </div>
      </div>
      <div className="modal-footer vendor-map-footer">
        <button type="button" className="vendor-map-cancel" onClick={() => setIsAgentMapOpen(false)}>Cancel</button>
       <button
  type="button"
  className="vendor-map-confirm"
  disabled={!agentMapMarker}
  onClick={() => {
    setDeliveryVendorAgentsData((prev) => ({
      ...prev,
      latitude: agentMapMarker.lat.toString(),
      longitude: agentMapMarker.lng.toString(),
    }));
    setAgentLocation(agentMapMarker);
    toast.success("Agent location selected!");
    setIsAgentMapOpen(false);
  }}
>
  Confirm Location
</button>
      </div>
    </div>
  </div>
</div>
        <Form className="agent-form">
          <div className="row mt-3">
            <div className="col-md-4">
              <Form.Group controlId="formDeliveryVendorName">
                <Form.Label>Delivery Vendor Name</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Form.Control
                  as="select"
                  name="personName"
                  className={`bg-light ${errors.personName ? 'is-invalid' : validFields.personName ? 'is-valid' : ''}`}
                  onChange={handleInputChangeAgents}
                  disabled={loading}
                >
                  <option value="">Select Delivery Vendor</option>
                  {deliveryVendors.map((deliveryVendor, index) => (
                    <option
                      key={index}
                      value={deliveryVendor.fullName}
                      data-id={deliveryVendor._id}
                      data-name={deliveryVendor.fullName}
                      data-email={deliveryVendor.emailAddress}
                    >
                      {deliveryVendor.fullName} ({deliveryVendor.emailAddress})
                    </option>
                  ))}
                </Form.Control>
                {errors.personName && <small className="text-danger">{errors.personName}</small>}
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group controlId="formFullName">
                <Form.Label>Delivery Agent Name</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Form.Control
                  type="text"
                  className={`bg-light ${errors.fullName ? 'is-invalid' : validFields.fullName ? 'is-valid' : ''}`}
                  name="fullName"
                  value={deliveryVendorAgentsData.fullName}
                  onChange={handleInputChangeAgents}
                />
                {errors.fullName && <small className="text-danger">{errors.fullName}</small>}
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group controlId="formBloodGroupRow">
                <Form.Label>Blood Group</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Form.Control
                  type="text"
                  className={`bg-light ${errors.bloodGroup ? 'is-invalid' : validFields.bloodGroup ? 'is-valid' : ''}`}
                  name="bloodGroup"
                  value={deliveryVendorAgentsData.bloodGroup}
                  onChange={handleInputChangeAgents}
                />
                {errors.bloodGroup && <small className="text-danger">{errors.bloodGroup}</small>}
              </Form.Group>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-4">
              <Form.Group controlId="formAddress">
                <Form.Label>Address</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Form.Control
                  type="text"
                  className={`bg-light ${errors.address ? 'is-invalid' : validFields.address ? 'is-valid' : ''}`}
                  name="address"
                  value={deliveryVendorAgentsData.address}
                  onChange={handleInputChangeAgents}
                />
                {errors.address && <small className="text-danger">{errors.address}</small>}
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group controlId="formWhatsAppNumber">
                <Form.Label>Primary Mobile Number</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Form.Control
                  type="text"
                  className={`bg-light ${errors.whatsAppNumber ? 'is-invalid' : validFields.whatsAppNumber ? 'is-valid' : ''}`}
                  name="whatsAppNumber"
                  value={deliveryVendorAgentsData.whatsAppNumber}
                  onChange={handleInputChangeAgents}
                  maxLength="10"
                  pattern="\d*"
                  inputMode="numeric"
                />
                {errors.whatsAppNumber && <small className="text-danger">{errors.whatsAppNumber}</small>}
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group controlId="formEmergencyContactNumber">
                <Form.Label>Emergency Contact Number</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Form.Control
                  type="text"
                  className={`bg-light ${errors.emergencyContactNumber ? 'is-invalid' : validFields.emergencyContactNumber ? 'is-valid' : ''}`}
                  name="emergencyContactNumber"
                  value={deliveryVendorAgentsData.emergencyContactNumber}
                  onChange={handleInputChangeAgents}
                  maxLength="10"
                  pattern="\d*"
                  inputMode="numeric"
                />
                {errors.emergencyContactNumber && <small className="text-danger">{errors.emergencyContactNumber}</small>}
              </Form.Group>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-4">
              <Form.Group controlId="formLanguagesKnown">
                <Form.Label>Languages Known</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Select
                  isMulti
                  name="languagesKnown"
                  options={languageOptions}
                  className={`basic-multi-select ${errors.languagesKnown ? 'is-invalid' : validFields.languagesKnown ? 'is-valid' : ''}`}
                  classNamePrefix="select"
                  onChange={handleInputChangeAgents}
                  value={languageOptions.filter((option) =>
                    deliveryVendorAgentsData.languagesKnown?.includes(option.value)
                  )}
                />
                {errors.languagesKnown && <small className="text-danger">{errors.languagesKnown}</small>}
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group controlId="formAadharNumber">
                <Form.Label>Aadhar Number</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Form.Control
                  type="text"
                  className={`bg-light ${errors.aadharNumber ? 'is-invalid' : validFields.aadharNumber ? 'is-valid' : ''}`}
                  name="aadharNumber"
                  value={deliveryVendorAgentsData.aadharNumber}
                  onChange={handleInputChangeAgents}
                />
                {errors.aadharNumber && <small className="text-danger">{errors.aadharNumber}</small>}
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group controlId="formAadharCardUpload" className="w-100">
                <Form.Label>Aadhar Card File Upload</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <div className="d-flex align-items-center">
                  <input
                    accept="application/pdf, image/*"
                    id="file-upload-button-aadharCardFileUpload"
                    type="file"
                    name="aadharCardFileUpload"
                    style={{ display: 'none' }}
                    onChange={handleFileChangeAgents}
                  />
                  <label htmlFor="file-upload-button-aadharCardFileUpload" className="w-100">
                    <Button
                      variant="contained"
                      component="span"
                      style={{
                        backgroundColor: '#00B982',
                        color: 'white',
                        width: '100%',
                        position: 'relative',
                        borderColor: uploadedFiles.aadharCardFileUpload ? '#00B982' : errors.aadharCardFileUpload ? 'red' : '',
                        borderWidth: uploadedFiles.aadharCardFileUpload || errors.aadharCardFileUpload ? '2px' : '0',
                        borderStyle: 'solid',
                      }}
                    >
                      {uploadedFiles.aadharCardFileUpload ? (
                        <>
                          {uploadedFiles.aadharCardFileUpload.name}
                          <img
                            src={cancelicon}
                            alt="Cancel"
                            onClick={() => handleRemoveFile('aadharCardFileUpload')}
                            style={{
                              width: '20px',
                              height: '20px',
                              marginLeft: '8px',
                              position: 'absolute',
                              right: '8px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              cursor: 'pointer',
                            }}
                          />
                        </>
                      ) : (
                        <>
                          Upload
                          <img src={uploadicon} alt="Upload" style={{ width: '20px', height: '20px', marginLeft: '8px' }} />
                        </>
                      )}
                    </Button>
                  </label>
                </div>
                {errors.aadharCardFileUpload && !uploadedFiles.aadharCardFileUpload && (
                  <small className="text-danger">{errors.aadharCardFileUpload}</small>
                )}
              </Form.Group>
            </div>
          </div>
          <div className="row mt-3">
     <div className="col-md-4">
  <Form.Group controlId="formUseMyLocation">
    <Form.Label>Use My Locationsss</Form.Label>
    <span style={{ color: 'red' }}>*</span>

    <button
      type="button"
      className={`agent-location-btn ${errors.latitude ? 'border-danger' : agentLocation ? 'border-success' : ''}`}
      onClick={() => setIsAgentMapOpen(true)}
    >
      <span>
        {agentLocation
          ? `Picked: ${agentLocation.lat.toFixed(4)}, ${agentLocation.lng.toFixed(4)}`
          : 'Pick Location on Map'}
      </span>
      <svg width="20" height="20" viewBox="0 0 25 24" fill="none" aria-hidden="true">
        <path d="M15.8 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" stroke="white" strokeWidth="1.5"/>
        <path d="M20.3 10.5C20.3 17.6 12.8 21.8 12.8 21.8S5.2 17.6 5.2 10.5a7.6 7.6 0 1 1 15.1 0Z" stroke="white" strokeWidth="1.5"/>
      </svg>
    </button>
    {agentLocation && (
      <button
        type="button"
        className="agent-clear-link"
        onClick={() => {
          setAgentLocation(null);
          setAgentMapMarker(null);
          setAgentManualLat('');
          setAgentManualLng('');
          setDeliveryVendorAgentsData(prev => ({
            ...prev,
            latitude: '',
            longitude: ''
          }));
        }}
      >
        Clear Location
      </button>
    )}

    {errors.latitude && <small className="text-danger">Location is required</small>}
  </Form.Group>
</div>
            <div className="col-md-4">
              <Form.Group controlId="formRCBookNumber">
                <Form.Label>RC Book Number</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Form.Control
                  type="text"
                  className={`bg-light ${errors.rcBookNumber ? 'is-invalid' : validFields.rcBookNumber ? 'is-valid' : ''}`}
                  name="rcBookNumber"
                  value={deliveryVendorAgentsData.rcBookNumber}
                  onChange={handleInputChangeAgents}
                />
                {errors.rcBookNumber && <small className="text-danger">{errors.rcBookNumber}</small>}
              </Form.Group>
            </div>
            <div className="col-md-4 d-flex align-items-center">
              <Form.Group controlId="formRCBookUpload" className="w-100">
                <Form.Label>RC Book Upload</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <div className="d-flex align-items-center">
                  <input
                    accept="application/pdf, image/*"
                    id="file-upload-button-rcBookUpload"
                    type="file"
                    name="rcBookUpload"
                    style={{ display: 'none' }}
                    onChange={handleFileChangeAgents}
                  />
                  <label htmlFor="file-upload-button-rcBookUpload" className="w-100">
                    <Button
                      variant="contained"
                      component="span"
                      style={{
                        backgroundColor: '#00B982',
                        color: 'white',
                        width: '100%',
                        position: 'relative',
                        borderColor: uploadedFiles.rcBookUpload ? '#00B982' : errors.rcBookUpload ? 'red' : '',
                        borderWidth: uploadedFiles.rcBookUpload || errors.rcBookUpload ? '2px' : '0',
                        borderStyle: 'solid',
                      }}
                    >
                      {uploadedFiles.rcBookUpload ? (
                        <>
                          {uploadedFiles.rcBookUpload.name}
                          <img
                            src={cancelicon}
                            alt="Cancel"
                            onClick={() => handleRemoveFile('rcBookUpload')}
                            style={{
                              width: '20px',
                              height: '20px',
                              marginLeft: '8px',
                              position: 'absolute',
                              right: '8px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              cursor: 'pointer',
                            }}
                          />
                        </>
                      ) : (
                        <>
                          Upload
                          <img src={uploadicon} alt="Upload" style={{ width: '20px', height: '20px', marginLeft: '8px' }} />
                        </>
                      )}
                    </Button>
                  </label>
                </div>
                {errors.rcBookUpload && !uploadedFiles.rcBookUpload && (
                  <small className="text-danger">{errors.rcBookUpload}</small>
                )}
              </Form.Group>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-4">
              <Form.Group controlId="formVehicleNumber">
                <Form.Label>Vehicle Number</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Form.Control
                  type="text"
                  className={`bg-light ${errors.vehicleNumber ? 'is-invalid' : validFields.vehicleNumber ? 'is-valid' : ''}`}
                  name="vehicleNumber"
                  value={deliveryVendorAgentsData.vehicleNumber}
                  onChange={handleInputChangeAgents}
                />
                {errors.vehicleNumber && <small className="text-danger">{errors.vehicleNumber}</small>}
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group controlId="formAccountNumber">
                <Form.Label>Account Number</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Form.Control
                  type="text"
                  className={`bg-light ${errors.accountNumber ? 'is-invalid' : validFields.accountNumber ? 'is-valid' : ''}`}
                  placeholder="Enter account number"
                  name="accountNumber"
                  value={deliveryVendorAgentsData.accountNumber}
                  onChange={handleInputChangeAgents}
                />
                {errors.accountNumber && <small className="text-danger">{errors.accountNumber}</small>}
              </Form.Group>
            </div>
            <div className="col-md-4 d-flex align-items-center">
              <Form.Group controlId="formPassBookUpload" className="w-100">
                <Form.Label>Pass Book Upload</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <div className="d-flex align-items-center">
                  <input
                    accept="application/pdf, image/*"
                    id="file-upload-button-passBookUpload"
                    type="file"
                    name="passBookUpload"
                    style={{ display: 'none' }}
                    onChange={handleFileChangeAgents}
                  />
                  <label htmlFor="file-upload-button-passBookUpload" className="w-100">
                    <Button
                      variant="contained"
                      component="span"
                      style={{
                        backgroundColor: '#00B982',
                        color: 'white',
                        width: '100%',
                        position: 'relative',
                        borderColor: uploadedFiles.passBookUpload ? '#00B982' : errors.passBookUpload ? 'red' : '',
                        borderWidth: uploadedFiles.passBookUpload || errors.passBookUpload ? '2px' : '0',
                        borderStyle: 'solid',
                      }}
                    >
                      {uploadedFiles.passBookUpload ? (
                        <>
                          {uploadedFiles.passBookUpload.name}
                          <img
                            src={cancelicon}
                            alt="Cancel"
                            onClick={() => handleRemoveFile('passBookUpload')}
                            style={{
                              width: '20px',
                              height: '20px',
                              marginLeft: '8px',
                              position: 'absolute',
                              right: '8px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              cursor: 'pointer',
                            }}
                          />
                        </>
                      ) : (
                        <>
                          Upload
                          <img src={uploadicon} alt="Upload" style={{ width: '20px', height: '20px', marginLeft: '8px' }} />
                        </>
                      )}
                    </Button>
                  </label>
                </div>
                {errors.passBookUpload && !uploadedFiles.passBookUpload && (
                  <small className="text-danger">{errors.passBookUpload}</small>
                )}
              </Form.Group>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-4">
              <Form.Group controlId="formIFSCCode">
                <Form.Label>IFSC Code</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Form.Control
                  type="text"
                  className={`bg-light ${errors.ifscCode ? 'is-invalid' : validFields.ifscCode ? 'is-valid' : ''}`}
                  placeholder="Enter IFSC code"
                  name="ifscCode"
                  value={deliveryVendorAgentsData.ifscCode}
                  onChange={handleInputChangeAgents}
                />
                {errors.ifscCode && <small className="text-danger">{errors.ifscCode}</small>}
              </Form.Group>
            </div>
            <div className="col-md-4 d-flex align-items-center">
              <Form.Group controlId="formBranchAddress" className="w-100">
                <Form.Label>Branch Address</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Form.Control
                  type="text"
                  placeholder="Enter branch address"
                  name="branchAddress"
                  value={deliveryVendorAgentsData.branchAddress}
                  className={`bg-light ${errors.branchAddress ? 'is-invalid' : validFields.branchAddress ? 'is-valid' : ''}`}
                  onChange={handleInputChangeAgents}
                />
                {errors.branchAddress && <small className="text-danger">{errors.branchAddress}</small>}
              </Form.Group>
            </div>
            <div className="col-md-4 d-flex align-items-center">
              <Form.Group controlId="formPanCardUpload" className="w-100">
                <Form.Label>PAN Card Upload</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <div className="d-flex align-items-center">
                  <input
                    accept="application/pdf, image/*"
                    id="file-upload-button-panCardUpload"
                    type="file"
                    name="panCardUpload"
                    style={{ display: 'none' }}
                    onChange={handleFileChangeAgents}
                  />
                  <label htmlFor="file-upload-button-panCardUpload" className="w-100">
                    <Button
                      variant="contained"
                      component="span"
                      style={{
                        backgroundColor: '#00B982',
                        color: 'white',
                        width: '100%',
                        position: 'relative',
                        borderColor: uploadedFiles.panCardUpload ? '#00B982' : errors.panCardUpload ? 'red' : '',
                        borderWidth: uploadedFiles.panCardUpload || errors.panCardUpload ? '2px' : '0',
                        borderStyle: 'solid',
                      }}
                    >
                      {uploadedFiles.panCardUpload ? (
                        <>
                          {uploadedFiles.panCardUpload.name}
                          <img
                            src={cancelicon}
                            alt="Cancel"
                            onClick={() => handleRemoveFile('panCardUpload')}
                            style={{
                              width: '20px',
                              height: '20px',
                              marginLeft: '8px',
                              position: 'absolute',
                              right: '8px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              cursor: 'pointer',
                            }}
                          />
                        </>
                      ) : (
                        <>
                          Upload
                          <img src={uploadicon} alt="Upload" style={{ width: '20px', height: '20px', marginLeft: '8px' }} />
                        </>
                      )}
                    </Button>
                  </label>
                </div>
                {errors.panCardUpload && !uploadedFiles.panCardUpload && (
                  <small className="text-danger">{errors.panCardUpload}</small>
                )}
              </Form.Group>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-4">
              <Form.Group controlId="formPanNumber">
                <Form.Label>PAN Number</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Form.Control
                  type="text"
                  placeholder="Enter PAN number"
                  className={`bg-light ${errors.panNumber ? 'is-invalid' : validFields.panNumber ? 'is-valid' : ''}`}
                  name="panNumber"
                  value={deliveryVendorAgentsData.panNumber}
                  onChange={handleInputChangeAgents}
                />
                {errors.panNumber && <small className="text-danger">{errors.panNumber}</small>}
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group controlId="formDrivingLicenseNumber">
                <Form.Label>Driving License Number</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Form.Control
                  type="text"
                  placeholder="Enter driving license number"
                  name="drivingLicenseNumber"
                  className={`bg-light ${errors.drivingLicenseNumber ? 'is-invalid' : validFields.drivingLicenseNumber ? 'is-valid' : ''}`}
                  value={deliveryVendorAgentsData.drivingLicenseNumber}
                  onChange={handleInputChangeAgents}
                />
                {errors.drivingLicenseNumber && <small className="text-danger">{errors.drivingLicenseNumber}</small>}
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group controlId="formDrivingLicenseUpload" className="w-100">
                <Form.Label>Driving License Upload</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <div className="d-flex align-items-center">
                  <input
                    accept="application/pdf, image/*"
                    id="file-upload-button-drivingLicenseUpload"
                    type="file"
                    name="drivingLicenseUpload"
                    style={{ display: 'none' }}
                    onChange={handleFileChangeAgents}
                  />
                  <label htmlFor="file-upload-button-drivingLicenseUpload" className="w-100">
                    <Button
                      variant="contained"
                      component="span"
                      style={{
                        backgroundColor: '#00B982',
                        color: 'white',
                        width: '100%',
                        position: 'relative',
                        borderColor: uploadedFiles.drivingLicenseUpload ? '#00B982' : errors.drivingLicenseUpload ? 'red' : '',
                        borderWidth: uploadedFiles.drivingLicenseUpload || errors.drivingLicenseUpload ? '2px' : '0',
                        borderStyle: 'solid',
                      }}
                    >
                      {uploadedFiles.drivingLicenseUpload ? (
                        <>
                          {uploadedFiles.drivingLicenseUpload.name}
                          <img
                            src={cancelicon}
                            alt="Cancel"
                            onClick={() => handleRemoveFile('drivingLicenseUpload')}
                            style={{
                              width: '20px',
                              height: '20px',
                              marginLeft: '8px',
                              position: 'absolute',
                              right: '8px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              cursor: 'pointer',
                            }}
                          />
                        </>
                      ) : (
                        <>
                          Upload
                          <img src={uploadicon} alt="Upload" style={{ width: '20px', height: '20px', marginLeft: '8px' }} />
                        </>
                      )}
                    </Button>
                  </label>
                </div>
                {errors.drivingLicenseUpload && !uploadedFiles.drivingLicenseUpload && (
                  <small className="text-danger">{errors.drivingLicenseUpload}</small>
                )}
              </Form.Group>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-4 d-flex align-items-center">
              <Form.Group controlId="formProfileImageUpload" className="w-100">
                <Form.Label>Profile Image Upload</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <div className="d-flex align-items-center">
                  <input
                    accept="image/*"
                    id="file-upload-button-profileImageUpload"
                    type="file"
                    name="profileImageUpload"
                    style={{ display: 'none' }}
                    onChange={handleFileChangeAgents}
                  />
                  <label htmlFor="file-upload-button-profileImageUpload" className="w-100">
                    <Button
                      variant="contained"
                      component="span"
                      style={{
                        backgroundColor: '#00B982',
                        color: 'white',
                        width: '100%',
                        position: 'relative',
                        borderColor: uploadedFiles.profileImageUpload ? '#00B982' : errors.profileImageUpload ? 'red' : '',
                        borderWidth: uploadedFiles.profileImageUpload || errors.profileImageUpload ? '2px' : '0',
                        borderStyle: 'solid',
                      }}
                    >
                      {uploadedFiles.profileImageUpload ? (
                        <>
                          {uploadedFiles.profileImageUpload.name}
                          <img
                            src={cancelicon}
                            alt="Cancel"
                            onClick={() => handleRemoveFile('profileImageUpload')}
                            style={{
                              width: '20px',
                              height: '20px',
                              marginLeft: '8px',
                              position: 'absolute',
                              right: '8px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              cursor: 'pointer',
                            }}
                          />
                        </>
                      ) : (
                        <>
                          Upload
                          <img src={uploadicon} alt="Upload" style={{ width: '20px', height: '20px', marginLeft: '8px' }} />
                        </>
                      )}
                    </Button>
                  </label>
                </div>
                {errors.profileImageUpload && !uploadedFiles.profileImageUpload && (
                  <small className="text-danger">{errors.profileImageUpload}</small>
                )}
              </Form.Group>
            </div>
          </div>
        </Form>
      </div>
    </div>
    <div className="delivery-form-actions">
      <button type="button" className="delivery-form-cancel" onClick={handleClose}>Cancel</button>
      <button type="button" className="delivery-form-submit" onClick={handleSubmitAgents}>Save</button>
    </div>
    </>
)}
{isEditAgentPage && (
  <>
    <header className="delivery-form-hero">
      <div>
        <p className="delivery-form-kicker">Vendors</p>
        <h1>Update Agent</h1>
        <p>Review and update the delivery agent details.</p>
      </div>
      <button type="button" className="delivery-form-back" onClick={handleAgentEditClose}>
        Back to Agents
      </button>
    </header>
    <div className="card">
      <div className="card-header"><h5>Agent Information</h5></div>
      <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <div className={`modal fade vendor-map-modal ${isAgentMapOpen ? 'show d-block' : ''}`} tabIndex="-1">
          <div className="modal-dialog modal-lg modal-dialog-centered vendor-map-dialog">
            <div className="modal-content vendor-map-content">
              <div className="modal-header vendor-map-header">
                <div>
                  <p>Vendors</p>
                  <h5 className="modal-title">Select location</h5>
                </div>
                <button type="button" className="btn-close" onClick={() => setIsAgentMapOpen(false)}></button>
              </div>
              <div className="modal-body vendor-map-body">
                <p className="vendor-map-hint">Search an address, enter coordinates, or click the map to drop a pin.</p>
                <div className="vendor-map-search">
                  <input
                    className="form-control"
                    placeholder="Search location..."
                    value={agentSearchQuery}
                    onChange={(e) => setAgentSearchQuery(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleAgentGeocode()}
                  />
                  <button type="button" className="vendor-map-search-btn" onClick={handleAgentGeocode}>
                    Search
                  </button>
                </div>

                <div className="vendor-map-coords">
                  <div>
                    <label>Latitude</label>
                    <input type="number" step="any" className="form-control" value={agentManualLat}
                      onChange={(e) => {
                        const v = e.target.value;
                        setAgentManualLat(v);
                        if (v && agentManualLng) updateAgentLocation({ lat: parseFloat(v), lng: parseFloat(agentManualLng) });
                      }} />
                  </div>
                  <div>
                    <label>Longitude</label>
                    <input type="number" step="any" className="form-control" value={agentManualLng}
                      onChange={(e) => {
                        const v = e.target.value;
                        setAgentManualLng(v);
                        if (v && agentManualLat) updateAgentLocation({ lat: parseFloat(agentManualLat), lng: parseFloat(v) });
                      }} />
                  </div>
                </div>

                <div className="vendor-map-frame">
                  <MapContainer center={[11.0168, 76.9558]} zoom={13} style={{ height: "100%", width: "100%" }} ref={mapRef}>
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    <MapClickHandler onSelect={updateAgentLocation} />
                    {agentMapMarker && <Marker position={[agentMapMarker.lat, agentMapMarker.lng]} />}
                  </MapContainer>
                </div>
              </div>
              <div className="modal-footer vendor-map-footer">
                <button type="button" className="vendor-map-cancel" onClick={() => setIsAgentMapOpen(false)}>Cancel</button>
              <button
          type="button"
          className="vendor-map-confirm"
          disabled={!agentMapMarker}
          onClick={() => {
            setDeliveryVendorAgentsData((prev) => ({
              ...prev,
              latitude: agentMapMarker.lat.toString(),
              longitude: agentMapMarker.lng.toString(),
            }));
            setAgentLocation(agentMapMarker);
            toast.success("Agent location selected!");
            setIsAgentMapOpen(false);
          }}
        >
          Confirm Location
        </button>
              </div>
            </div>
          </div>
        </div>
          <Form className="agent-form">
            <div className="row mt-3">
         <div className="col-md-4">
                <Form.Group controlId="deliveryVendorName">
                  <Form.Label>Delivery Vendor Name</Form.Label>
                  <span style={{ color: 'red' }}>*</span>
                  <Form.Control type="text" 
                  className={`bg-light ${errors.personName ? "is-invalid" : validFields.personName ? "is-valid" : ""}`}
                  name="deliveryVendorName"
                  value={`${deliveryVendorAgentsData.deliveryVendorName} (${deliveryVendorAgentsData.deliveryVendorEmail || ''})`}
                  onChange={handleInputChangeAgents}
                  readOnly/>
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group controlId="formFullName">
                  <Form.Label>Delivery Agent Name</Form.Label>
                  <span style={{ color: 'red' }}>*</span>
                  <Form.Control type="text" 
                  className={`bg-light ${errors.fullName ? "is-invalid" : validFields.fullName ? "is-valid" : ""}`}
                  name="fullName"
                  value={deliveryVendorAgentsData.fullName}
                  onChange={handleInputChangeAgents}/>
                  {errors.fullName && <small className="text-danger">{errors.fullName}</small>}
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group controlId="formBloodGroupRow">
                  <Form.Label>Blood Group</Form.Label>
                  <span style={{ color: 'red' }}>*</span>
                  <Form.Control type="text" 
                  className={`bg-light ${errors.bloodGroup ? "is-invalid" : validFields.bloodGroup ? "is-valid" : ""}`}
                  name="bloodGroup"
                  value={deliveryVendorAgentsData.bloodGroup}
                  onChange={handleInputChangeAgents}/>
                  {errors.bloodGroup && <small className="text-danger">{errors.bloodGroup}</small>}
                </Form.Group>
              </div>
             
            </div>
            <div className="row mt-3">
            <div className="col-md-4">
                <Form.Group controlId="formAddress">
                  <Form.Label>Address</Form.Label>
                  <span style={{ color: 'red' }}>*</span>
                  <Form.Control type="text" 
                  className={`bg-light ${errors.address ? "is-invalid" : validFields.address ? "is-valid" : ""}`}
                  name="address"
                  value={deliveryVendorAgentsData.address}
                  onChange={handleInputChangeAgents}/>
                   {errors.address && <small className="text-danger">{errors.address}</small>}
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group controlId="formWhatsAppNumber">
                  <Form.Label>Primary Mobile Number</Form.Label>
                  <span style={{ color: 'red' }}>*</span>
                  <Form.Control type="text" 
                  className={`bg-light ${errors.whatsAppNumber ? "is-invalid" : validFields.whatsAppNumber ? "is-valid" : ""}`}
                   name="whatsAppNumber"
                   value={deliveryVendorAgentsData.whatsAppNumber}
                   onChange={handleInputChangeAgents}
                   maxLength="10"
                   pattern="\d*"
                   inputMode="numeric"/>
                    {errors.whatsAppNumber && <small className="text-danger">{errors.whatsAppNumber}</small>}
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group controlId="formEmergencyContactNumber">
                  <Form.Label>Emergency Contact Number</Form.Label>
                  <span style={{ color: 'red' }}>*</span>
                  <Form.Control type="text" 
                  className={`bg-light ${errors.emergencyContactNumber ? "is-invalid" : validFields.emergencyContactNumber ? "is-valid" : ""}`}
                   name="emergencyContactNumber"
                   value={deliveryVendorAgentsData.emergencyContactNumber}
                   onChange={handleInputChangeAgents}
                   maxLength="10"
                   pattern="\d*"
                   inputMode="numeric"/>
                    {errors.emergencyContactNumber && (
                  <small className="text-danger">{errors.emergencyContactNumber}</small>
                )}
                </Form.Group>
              </div>
            </div>
            <div className="row mt-3">
                  <div className="col-md-4">
                <Form.Group controlId="formLanguagesKnown">
                    <Form.Label>Languages Known</Form.Label>
                    <span style={{ color: 'red' }}>*</span>
                    <Select
                      isMulti
                      name="languagesKnown"
                      options={languageOptions}
                      className={`basic-multi-select ${errors.languagesKnown ? "is-invalid" : validFields.languagesKnown ? "is-valid" : ""}`}
                      classNamePrefix="select"
                      onChange={handleInputChangeAgents}
                      value={languageOptions.filter((option) =>
                        deliveryVendorAgentsData.languagesKnown?.includes(option.value)
                      )}
                    />
                    {errors.languagesKnown && <small className="text-danger">{errors.languagesKnown}</small>}
                  </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group controlId="formUseMyLocationEdit">
                  <Form.Label>Use My Location</Form.Label>
                  <span style={{ color: 'red' }}>*</span>

                  <button
                    type="button"
                    className={`agent-location-btn ${errors.latitude ? 'border-danger' : agentLocation ? 'border-success' : ''}`}
                    onClick={() => setIsAgentMapOpen(true)}
                  >
                    <span>
                      {agentLocation
                        ? `Picked: ${agentLocation.lat.toFixed(4)}, ${agentLocation.lng.toFixed(4)}`
                        : 'Pick Location on Map'}
                    </span>
                    <svg width="20" height="20" viewBox="0 0 25 24" fill="none" aria-hidden="true">
                      <path d="M15.8 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" stroke="white" strokeWidth="1.5"/>
                      <path d="M20.3 10.5C20.3 17.6 12.8 21.8 12.8 21.8S5.2 17.6 5.2 10.5a7.6 7.6 0 1 1 15.1 0Z" stroke="white" strokeWidth="1.5"/>
                    </svg>
                  </button>
                  {agentLocation && (
                    <button
                      type="button"
                      className="agent-clear-link"
                      onClick={() => {
                        setAgentLocation(null);
                        setAgentMapMarker(null);
                        setAgentManualLat('');
                        setAgentManualLng('');
                        setDeliveryVendorAgentsData(prev => ({
                          ...prev,
                          latitude: '',
                          longitude: ''
                        }));
                      }}
                    >
                      Clear Location
                    </button>
                  )}

                  {errors.latitude && <small className="text-danger">Location is required</small>}
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group controlId="formAadharNumber">
                  <Form.Label>Aadhar Number</Form.Label>
                  <span style={{ color: 'red' }}>*</span>
                  <Form.Control type="text" 
                  className={`bg-light ${errors.aadharNumber ? "is-invalid" : validFields.aadharNumber ? "is-valid" : ""}`}
                  name="aadharNumber"
                  value={deliveryVendorAgentsData.aadharNumber}
                  onChange={handleInputChangeAgents}/>
                   {errors.aadharNumber && <small className="text-danger">{errors.aadharNumber}</small>}
                </Form.Group>
              </div>
            </div>
            <div className="row mt-3">
           <div className="col-md-4">
            <Form.Group controlId="formAadharCardUpload" className="w-100">
              <Form.Label>Aadhar Card File Upload</Form.Label>
              <span style={{ color: 'red' }}>*</span>
              <div className="d-flex flex-column align-items-center">
                <input
                  accept="application/pdf, image/*, .doc, .docx"
                  id="file-upload-button-aadharCardFileUpload"
                  type="file"
                  name="aadharCardFileUpload"
                  style={{ display: 'none' }}
                  onChange={handleFileChangeAgents}
                />
                <label htmlFor="file-upload-button-aadharCardFileUpload" className="w-100">
                  <Button
                    variant="contained"
                    component="span"
                    style={{ backgroundColor: '#00B982', color: 'white', width: '100%', position: 'relative' }}
                  >
                    {uploadedFiles.aadharCardFileUpload ? (
                      <>
                        {uploadedFiles.aadharCardFileUpload.name}
                        <img
                          src={cancelicon}
                          alt="Cancel"
                          onClick={() => handleRemoveFile('aadharCardFileUpload')}
                          style={{
                            width: '20px',
                            height: '20px',
                            marginLeft: '8px',
                            position: 'absolute',
                            right: '8px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                          }}
                        />
                      </>
                    ) : (
                      <>
                        Upload
                        <img src={uploadicon} alt="Upload" style={{ width: '20px', height: '20px', marginLeft: '8px' }} />
                      </>
                    )}
                  </Button>
                </label>
                {(uploadedFiles.aadharCardFileUpload || deliveryVendorAgentsData.aadharCardFileUpload) && (
                  <div
                    className="file-preview mt-3"
                    style={{
                      width: '50px',
                      height: '50px',
                      borderRadius: '5px',
                      boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
                      overflow: 'hidden',
                    }}
                  >
                    {uploadedFiles.aadharCardFileUpload?.file ||
                    deliveryVendorAgentsData.aadharCardFileUpload ? (
                      <>
                        {(uploadedFiles.aadharCardFileUpload?.file?.type.startsWith('image') ||
                          (deliveryVendorAgentsData.aadharCardFileUpload &&
                            deliveryVendorAgentsData.aadharCardFileUpload.endsWith('.png') ||
                            deliveryVendorAgentsData.aadharCardFileUpload.endsWith('.jpg') ||
                            deliveryVendorAgentsData.aadharCardFileUpload.endsWith('.jpeg'))) ? (
                          <img
                            src={
                              uploadedFiles.aadharCardFileUpload?.file
                                ? URL.createObjectURL(uploadedFiles.aadharCardFileUpload.file)
                                : deliveryVendorAgentsData.aadharCardFileUpload
                            }
                            alt="Preview"
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                        ) : (
                          <a
                            href={
                              uploadedFiles.aadharCardFileUpload?.file
                                ? URL.createObjectURL(uploadedFiles.aadharCardFileUpload.file)
                                : deliveryVendorAgentsData.aadharCardFileUpload
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              width: '100%',
                              height: '100%',
                              textDecoration: 'none',
                              color: '#00B982',
                              fontSize: '10px',
                            }}
                          >
                            View File
                          </a>
                        )}
                      </>
                    ) : null}
                  </div>
                )}
              </div>
            </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group controlId="formRCBookNumber">
                <Form.Label>RC Book Number</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Form.Control type="text" 
                className={`bg-light ${errors.rcBookNumber ? "is-invalid" : validFields.rcBookNumber ? "is-valid" : ""}`}
                 name="rcBookNumber"
                 value={deliveryVendorAgentsData.rcBookNumber}
                 onChange={handleInputChangeAgents}/>
                 {errors.rcBookNumber && <small className="text-danger">{errors.rcBookNumber}</small>}
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group controlId="formRCBookUpload" className="w-100">
                <Form.Label>RC Book Upload</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <div className="d-flex flex-column align-items-center">
                  <input
                    accept="application/pdf, image/*, .doc, .docx"
                    id="file-upload-button-rcBookUpload"
                    type="file"
                    name="rcBookUpload"
                    style={{ display: 'none' }}
                    onChange={handleFileChangeAgents}
                  />
                  <label htmlFor="file-upload-button-rcBookUpload" className="w-100">
                    <Button
                      variant="contained"
                      component="span"
                      style={{ backgroundColor: '#00B982', color: 'white', width: '100%', position: 'relative' }}
                    >
                      {uploadedFiles.rcBookUpload ? (
                        <>
                          {uploadedFiles.rcBookUpload.name}
                          <img
                            src={cancelicon}
                            alt="Cancel"
                            onClick={() => handleRemoveFile('rcBookUpload')}
                            style={{
                              width: '20px',
                              height: '20px',
                              marginLeft: '8px',
                              position: 'absolute',
                              right: '8px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              cursor: 'pointer',
                            }}
                          />
                        </>
                      ) : (
                        <>
                          Upload
                          <img src={uploadicon} alt="Upload" style={{ width: '20px', height: '20px', marginLeft: '8px' }} />
                        </>
                      )}
                    </Button>
                  </label>
                  {(uploadedFiles.rcBookUpload || deliveryVendorAgentsData.rcBookUpload) && (
                    <div
                      className="file-preview mt-3"
                      style={{
                        width: '50px',
                        height: '50px',
                        borderRadius: '5px',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
                        overflow: 'hidden',
                      }}
                    >
                      {uploadedFiles.rcBookUpload?.file || deliveryVendorAgentsData.rcBookUpload ? (
                        <>
                          {(uploadedFiles.rcBookUpload?.file?.type.startsWith('image') ||
                            (deliveryVendorAgentsData.rcBookUpload &&
                              (deliveryVendorAgentsData.rcBookUpload.endsWith('.png') ||
                                deliveryVendorAgentsData.rcBookUpload.endsWith('.jpg') ||
                                deliveryVendorAgentsData.rcBookUpload.endsWith('.jpeg')))) ? (
                            <img
                              src={
                                uploadedFiles.rcBookUpload?.file
                                  ? URL.createObjectURL(uploadedFiles.rcBookUpload.file)
                                  : deliveryVendorAgentsData.rcBookUpload
                              }
                              alt="Preview"
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                          ) : (
                            <a
                              href={
                                uploadedFiles.rcBookUpload?.file
                                  ? URL.createObjectURL(uploadedFiles.rcBookUpload.file)
                                  : deliveryVendorAgentsData.rcBookUpload
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                height: '100%',
                                textDecoration: 'none',
                                color: '#00B982',
                                fontSize: '10px',
                              }}
                            >
                              View File
                            </a>
                          )}
                        </>
                      ) : null}
                    </div>
                  )}
                </div>
              </Form.Group>
            </div>
            </div>
            <div className="row mt-3">
            <div className="col-md-4">
              <Form.Group controlId="formVehicleNumber">
                <Form.Label>Vehicle Number</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Form.Control type="text" 
                className={`bg-light ${errors.vehicleNumber ? "is-invalid" : validFields.vehicleNumber ? "is-valid" : ""}`}
                name="vehicleNumber"
                value={deliveryVendorAgentsData.vehicleNumber}
                onChange={handleInputChangeAgents}/>
                 {errors.vehicleNumber && <small className="text-danger">{errors.vehicleNumber}</small>}
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group controlId="formAccountNumber">
                <Form.Label>Account Number</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Form.Control type="text" 
                className={`bg-light ${errors.accountNumber ? "is-invalid" : validFields.accountNumber ? "is-valid" : ""}`}
                placeholder="Enter account number" 
                name="accountNumber"
                value={deliveryVendorAgentsData.accountNumber}
                onChange={handleInputChangeAgents}/>
                 {errors.accountNumber && <small className="text-danger">{errors.accountNumber}</small>}
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group controlId="formPassBookUpload" className="w-100">
                <Form.Label>Pass Book Upload</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <div className="d-flex flex-column align-items-center">
                  <input
                    accept="application/pdf, image/*, .doc, .docx"
                    id="file-upload-button-passBookUpload"
                    type="file"
                    name="passBookUpload"
                    style={{ display: 'none' }}
                    onChange={handleFileChangeAgents}
                  />
                  <label htmlFor="file-upload-button-passBookUpload" className="w-100">
                    <Button
                      variant="contained"
                      component="span"
                      style={{ backgroundColor: '#00B982', color: 'white', width: '100%', position: 'relative' }}
                    >
                      {uploadedFiles.passBookUpload ? (
                        <>
                          {uploadedFiles.passBookUpload.name}
                          <img
                            src={cancelicon}
                            alt="Cancel"
                            onClick={() => handleRemoveFile('passBookUpload')}
                            style={{
                              width: '20px',
                              height: '20px',
                              marginLeft: '8px',
                              position: 'absolute',
                              right: '8px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              cursor: 'pointer',
                            }}
                          />
                        </>
                      ) : (
                        <>
                          Upload
                          <img src={uploadicon} alt="Upload" style={{ width: '20px', height: '20px', marginLeft: '8px' }} />
                        </>
                      )}
                    </Button>
                  </label>

                  {(uploadedFiles.passBookUpload || deliveryVendorAgentsData.passBookUpload) && (
                    <div
                      className="file-preview mt-3"
                      style={{
                        width: '50px',
                        height: '50px',
                        borderRadius: '5px',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
                        overflow: 'hidden',
                      }}
                    >
                      {uploadedFiles.passBookUpload?.file || deliveryVendorAgentsData.passBookUpload ? (
                        <>
                          {(uploadedFiles.passBookUpload?.file?.type.startsWith('image') ||
                            (deliveryVendorAgentsData.passBookUpload &&
                              (deliveryVendorAgentsData.passBookUpload.endsWith('.png') ||
                                deliveryVendorAgentsData.passBookUpload.endsWith('.jpg') ||
                                deliveryVendorAgentsData.passBookUpload.endsWith('.jpeg')))) ? (
                            <img
                              src={
                                uploadedFiles.passBookUpload?.file
                                  ? URL.createObjectURL(uploadedFiles.passBookUpload.file)
                                  : deliveryVendorAgentsData.passBookUpload
                              }
                              alt="Preview"
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                          ) : (
                            <a
                              href={
                                uploadedFiles.passBookUpload?.file
                                  ? URL.createObjectURL(uploadedFiles.passBookUpload.file)
                                  : deliveryVendorAgentsData.passBookUpload
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                height: '100%',
                                textDecoration: 'none',
                                color: '#00B982',
                                fontSize: '10px',
                              }}
                            >
                              View File
                            </a>
                          )}
                        </>
                      ) : null}
                    </div>
                  )}
                </div>
              </Form.Group>
            </div>
            </div>
            <div className="row mt-3">
            <div className="col-md-4">
              <Form.Group controlId="formIFSCCode">
                <Form.Label>IFSC Code</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Form.Control type="text" 
                className={`bg-light ${errors.ifscCode ? "is-invalid" : validFields.ifscCode ? "is-valid" : ""}`}
                placeholder="Enter IFSC code" 
                name="ifscCode"
                value={deliveryVendorAgentsData.ifscCode}
                onChange={handleInputChangeAgents}/>
                {errors.ifscCode && <small className="text-danger">{errors.ifscCode}</small>}
              </Form.Group>
            </div>
            <div className="col-md-4 d-flex align-items-center">
              <Form.Group controlId="formBranchAddress" className="w-100">
                <Form.Label>Branch Address</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Form.Control type="text" placeholder="Enter branch address" 
                name="branchAddress"
                className={`bg-light ${errors.branchAddress ? "is-invalid" : validFields.branchAddress ? "is-valid" : ""}`}
                value={deliveryVendorAgentsData.branchAddress}
                onChange={handleInputChangeAgents}/>
                {errors.branchAddress && <small className="text-danger">{errors.branchAddress}</small>}
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group controlId="formPanCardUpload" className="w-100">
                <Form.Label>PAN Card Upload</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <div className="d-flex flex-column align-items-center">
                  <input
                    accept="application/pdf, image/*, .doc, .docx"
                    id="file-upload-button-panCardUpload"
                    type="file"
                    name="panCardUpload"
                    style={{ display: 'none' }}
                    onChange={handleFileChangeAgents}
                  />
                  <label htmlFor="file-upload-button-panCardUpload" className="w-100">
                    <Button
                      variant="contained"
                      component="span"
                      style={{ backgroundColor: '#00B982', color: 'white', width: '100%', position: 'relative' }}
                    >
                      {uploadedFiles.panCardUpload ? (
                        <>
                          {uploadedFiles.panCardUpload.name}
                          <img
                            src={cancelicon}
                            alt="Cancel"
                            onClick={() => handleRemoveFile('panCardUpload')}
                            style={{
                              width: '20px',
                              height: '20px',
                              marginLeft: '8px',
                              position: 'absolute',
                              right: '8px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              cursor: 'pointer',
                            }}
                          />
                        </>
                      ) : (
                        <>
                          Upload
                          <img src={uploadicon} alt="Upload" style={{ width: '20px', height: '20px', marginLeft: '8px' }} />
                        </>
                      )}
                    </Button>
                  </label>
                  {(uploadedFiles.panCardUpload || deliveryVendorAgentsData.panCardUpload) && (
                    <div
                      className="file-preview mt-3"
                      style={{
                        width: '50px',
                        height: '50px',
                        borderRadius: '5px',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
                        overflow: 'hidden',
                      }}
                    >
                      {uploadedFiles.panCardUpload?.file || deliveryVendorAgentsData.panCardUpload ? (
                        <>
                          {(uploadedFiles.panCardUpload?.file?.type.startsWith('image') ||
                            (deliveryVendorAgentsData.panCardUpload &&
                              (deliveryVendorAgentsData.panCardUpload.endsWith('.png') ||
                                deliveryVendorAgentsData.panCardUpload.endsWith('.jpg') ||
                                deliveryVendorAgentsData.panCardUpload.endsWith('.jpeg')))) ? (
                            <img
                              src={
                                uploadedFiles.panCardUpload?.file
                                  ? URL.createObjectURL(uploadedFiles.panCardUpload.file)
                                  : deliveryVendorAgentsData.panCardUpload
                              }
                              alt="Preview"
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                          ) : (
                            <a
                              href={
                                uploadedFiles.panCardUpload?.file
                                  ? URL.createObjectURL(uploadedFiles.panCardUpload.file)
                                  : deliveryVendorAgentsData.panCardUpload
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                height: '100%',
                                textDecoration: 'none',
                                color: '#00B982',
                                fontSize: '10px',
                              }}
                            >
                              {uploadedFiles.panCardUpload?.file.name || 'View File'}
                            </a>
                          )}
                        </>
                      ) : null}
                    </div>
                  )}
                </div>
              </Form.Group>
            </div>
            </div>
            <div className="row mt-3">
            <div className="col-md-4">
              <Form.Group controlId="formPanNumber">
                <Form.Label>PAN Number</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Form.Control type="text" placeholder="Enter PAN number" 
                className={`bg-light ${errors.panNumber ? "is-invalid" : validFields.panNumber ? "is-valid" : ""}`}
                name="panNumber"
                value={deliveryVendorAgentsData.panNumber}
                onChange={handleInputChangeAgents}/>
                 {errors.panNumber && <small className="text-danger">{errors.panNumber}</small>}
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group controlId="formDrivingLicenseNumber">
                <Form.Label>Driving License Number</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <Form.Control type="text" placeholder="Enter driving license number" 
                name="drivingLicenseNumber"
                className={`bg-light ${errors.drivingLicenseNumber ? "is-invalid" : validFields.drivingLicenseNumber ? "is-valid" : ""}`}
                value={deliveryVendorAgentsData.drivingLicenseNumber}
                onChange={handleInputChangeAgents}/>
                 {errors.drivingLicenseNumber && (
                  <small className="text-danger">{errors.drivingLicenseNumber}</small>
                )}
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group controlId="formDrivingLicenseUpload" className="w-100">
                <Form.Label>Driving License Upload</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <div className="d-flex flex-column align-items-center">
                  <input
                    accept="application/pdf, image/*, .doc, .docx"
                    id="file-upload-button-drivingLicenseUpload"
                    type="file"
                    name="drivingLicenseUpload"
                    style={{ display: 'none' }}
                    onChange={handleFileChangeAgents}
                  />
                  <label htmlFor="file-upload-button-drivingLicenseUpload" className="w-100">
                    <Button
                      variant="contained"
                      component="span"
                      style={{ backgroundColor: '#00B982', color: 'white', width: '100%', position: 'relative' }}
                    >
                      {uploadedFiles?.drivingLicenseUpload ? (
                        <>
                          {uploadedFiles.drivingLicenseUpload?.name || 'No file name'}
                          <img
                            src={cancelicon}
                            alt="Cancel"
                            onClick={() => handleRemoveFile('drivingLicenseUpload')}
                            style={{
                              width: '20px',
                              height: '20px',
                              marginLeft: '8px',
                              position: 'absolute',
                              right: '8px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              cursor: 'pointer',
                            }}
                          />
                        </>
                      ) : (
                        <>
                          Upload
                          <img src={uploadicon} alt="Upload" style={{ width: '20px', height: '20px', marginLeft: '8px' }} />
                        </>
                      )}
                    </Button>
                  </label>
                  {(uploadedFiles?.drivingLicenseUpload || deliveryVendorAgentsData?.drivingLicenseUpload) && (
                    <div
                      className="file-preview mt-3"
                      style={{
                        width: '50px',
                        height: '50px',
                        borderRadius: '5px',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
                        overflow: 'hidden',
                      }}
                    >
                      {uploadedFiles?.drivingLicenseUpload?.file || deliveryVendorAgentsData?.drivingLicenseUpload ? (
                        <>
                          {(uploadedFiles?.drivingLicenseUpload?.file?.type?.startsWith('image') ||
                            (deliveryVendorAgentsData?.drivingLicenseUpload &&
                              (deliveryVendorAgentsData?.drivingLicenseUpload.endsWith('.png') ||
                                deliveryVendorAgentsData?.drivingLicenseUpload.endsWith('.jpg') ||
                                deliveryVendorAgentsData?.drivingLicenseUpload.endsWith('.jpeg')))) ? (
                            <img
                              src={
                                uploadedFiles?.drivingLicenseUpload?.file
                                  ? URL.createObjectURL(uploadedFiles?.drivingLicenseUpload?.file)
                                  : deliveryVendorAgentsData?.drivingLicenseUpload
                              }
                              alt="Preview"
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                          ) : (
                            <a
                              href={
                                uploadedFiles?.drivingLicenseUpload?.file
                                  ? URL.createObjectURL(uploadedFiles?.drivingLicenseUpload?.file)
                                  : deliveryVendorAgentsData?.drivingLicenseUpload
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                height: '100%',
                                textDecoration: 'none',
                                color: '#00B982',
                                fontSize: '10px',
                              }}
                            >
                              {uploadedFiles?.drivingLicenseUpload?.file?.name || 'View File'}
                            </a>
                          )}
                        </>
                      ) : null}
                    </div>
                  )}
                </div>
              </Form.Group>
            </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-4 d-flex align-items-center">
              <Form.Group controlId="formProfileImageUpload" className="w-100">
                <Form.Label>Profile Image Upload</Form.Label>
                <span style={{ color: 'red' }}>*</span>
                <div className="d-flex flex-column align-items-center">
                  <input
                    accept="image/*"
                    id="file-upload-button-profileImageUpload"
                    type="file"
                    name="profileImageUpload"
                    style={{ display: 'none' }}
                    onChange={handleFileChangeAgents}
                  />
                  <label htmlFor="file-upload-button-profileImageUpload" className="w-100">
                  <Button
                    variant="contained"
                    component="span"
                    style={{ backgroundColor: '#00B982', color: 'white', width: '100%', position: 'relative' }}
                  >
                    {uploadedFiles.profileImageUpload?.name || 'Upload'}
                    <img
                      src={uploadicon}
                      alt="Upload"
                      style={{
                        width: '20px',
                        height: '20px',
                        marginLeft: '8px',
                      }}
                    />
                    {uploadedFiles.profileImageUpload && (
                      <img
                        src={cancelicon}
                        alt="Cancel"
                        onClick={() => handleRemoveFile('profileImageUpload')}
                        style={{
                          width: '20px',
                          height: '20px',
                          marginLeft: '8px',
                          position: 'absolute',
                          right: '8px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer',
                        }}
                      />
                    )}
                  </Button>

                  </label>
                  {(uploadedFiles.profileImageUpload || deliveryVendorAgentsData.profileImageUpload) && (
                    <div
                      className="image-preview mt-3"
                      style={{
                        width: '50px',
                        height: '50px',
                        borderRadius: '5px',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
                        overflow: 'hidden',
                      }}
                    >
                     <img
                        src={
                          uploadedFiles.profileImageUpload?.file
                            ? URL.createObjectURL(uploadedFiles.profileImageUpload.file) 
                            : deliveryVendorAgentsData.profileImageUpload 
                        }
                        alt="Preview"
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />

                    </div>
                  )}
                </div>
              </Form.Group>
            </div>

          </div>
          </Form>
      </div>
    </div>
    <div className="delivery-form-actions">
      <button type="button" className="delivery-form-cancel" onClick={handleAgentEditClose}>Cancel</button>
      <button type="button" className="delivery-form-submit" onClick={handleSaveChanges}>Update Agent</button>
    </div>
  </>
)}
    {!isAgentsPage && !isAgentFormPage && (
    <div className="delivery-form-actions">
                <button type="button" className="delivery-form-cancel" onClick={() => navigate('/view-delivery-vendor')}>Cancel</button>
                <button type="button" className="delivery-form-submit" onClick={handleSubmit}>Save and Submit</button>
      </div>
    )}
      {/* Advanced Location Picker Modal */}
      <div className={`modal fade vendor-map-modal ${isMapOpen ? 'show d-block' : ''}`} tabIndex="-1">
        <div className="modal-dialog modal-lg modal-dialog-centered vendor-map-dialog">
          <div className="modal-content vendor-map-content">
            <div className="modal-header vendor-map-header">
              <div>
                <p>Vendors</p>
                <h5 className="modal-title">Select location</h5>
              </div>
              <button type="button" className="btn-close" onClick={() => setIsMapOpen(false)}></button>
            </div>
            <div className="modal-body vendor-map-body">
              <p className="vendor-map-hint">Search an address, enter coordinates, or click the map to drop a pin.</p>
              <div className="vendor-map-search">
                <input
                  className="form-control"
                  placeholder="Search location..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleGeocode()}
                />
                <button
                  type="button"
                  className="vendor-map-search-btn"
                  onClick={handleGeocode}
                  disabled={!searchQuery.trim()}
                >
                  Search
                </button>
              </div>
              <div className="vendor-map-coords">
                <div>
                  <label>Latitude</label>
                  <input type="number" step="any" className="form-control" value={manualLat}
                    onChange={(e) => {
                      const v = e.target.value;
                      setManualLat(v);
                      if (v && manualLng) updateLocation({ lat: parseFloat(v), lng: parseFloat(manualLng) });
                    }} />
                </div>
                <div>
                  <label>Longitude</label>
                  <input type="number" step="any" className="form-control" value={manualLng}
                    onChange={(e) => {
                      const v = e.target.value;
                      setManualLng(v);
                      if (v && manualLat) updateLocation({ lat: parseFloat(manualLat), lng: parseFloat(v) });
                    }} />
                </div>
              </div>
              <div className="vendor-map-frame">
                <MapContainer
                  center={[11.0168, 76.9558]} 
                  zoom={13}
                  style={{ height: "100%", width: "100%" }}
                  ref={mapRef}
                >
                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                  <MapClickHandler onSelect={updateLocation} />
                  {mapMarker && <Marker position={[mapMarker.lat, mapMarker.lng]} />}
                </MapContainer>
              </div>
            </div>
            <div className="modal-footer vendor-map-footer">
              <button type="button" className="vendor-map-cancel" onClick={() => setIsMapOpen(false)}>Cancel</button>
              <button
                type="button"
                className="vendor-map-confirm"
                disabled={!mapMarker}
                onClick={() => {
                  setFormData(prev => ({
                    ...prev,
                    useMyLocation: {
                      latitude: mapMarker.lat.toString(),
                      longitude: mapMarker.lng.toString()
                    }
                  }));
                  setIsLocationPicked(true);
                  setErrors(prev => ({ ...prev, useMyLocation: '' }));
                  setValidFields(prev => ({ ...prev, useMyLocation: true }));
                  toast.success("Location selected successfully!");
                  setIsMapOpen(false);
                }}
              >
                Confirm Location
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div className="delivery-form-footer"><Footer/></div>
      <ToastContainer/>

      {/* <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ zIndex: 9999 }} 
      /> */}
      </div>
</>
  )
}

export default AddDeliveryVendor